var _rect, _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _g19, _path22, _g20, _path23, _g21, _path24, _g22, _path25, _g23, _path26, _g24, _path27, _g25, _path28, _g26, _path29, _g27, _path30, _g28, _path31, _g29, _path32, _g30, _path33, _g31, _path34, _g32, _path35, _g33, _path36, _g34, _path37, _g35, _path38, _g36, _path39, _g37, _path40, _g38, _path41, _g39, _path42, _g40, _path43, _g41, _path44, _g42, _path45, _g43, _path46, _g44, _path47, _g45, _path48, _g46, _path49, _g47, _path50, _g48, _path51, _g49, _path52, _g50, _path53, _g51, _path54, _g52, _path55, _g53, _path56, _g54, _path57, _g55, _path58, _g56, _path59, _g57, _path60, _g58, _path61, _g59, _path62, _g60, _path63, _g61, _path64, _g62, _path65, _g63, _path66, _g64, _path67, _g65, _path68, _g66, _path69, _g67, _path70, _g68, _path71, _g69, _path72, _g70, _path73, _g71, _path74, _g72, _path75, _g73, _path76, _g74, _path77, _g75, _path78, _g76, _path79, _g77, _path80, _g78, _path81, _g79, _path82, _g80, _path83, _g81, _path84, _g82, _path85, _g83, _path86, _g84, _path87, _g85, _path88, _g86, _path89, _g87, _path90, _g88, _path91, _g89, _path92, _g90, _path93, _g91, _path94, _g92, _path95, _g93, _path96, _g94, _path97, _g95, _path98, _g96, _path99, _g97, _path100, _g98, _path101, _g99, _path102, _g100, _path103, _g101, _path104, _g102, _path105, _g103, _path106, _g104, _path107, _g105, _path108, _g106, _path109, _g107, _path110, _g108, _path111, _g109, _path112, _g110, _path113, _g111, _path114, _g112, _path115, _g113, _path116, _g114, _path117, _g115, _path118, _g116, _path119, _g117, _path120, _g118, _path121, _g119, _path122, _g120, _path123, _g121, _path124, _g122, _path125, _g123, _path126, _g124, _path127, _g125, _path128, _g126, _path129, _g127, _path130, _g128, _path131, _g129, _path132, _g130, _path133, _g131, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _rect2, _path141, _g132, _path142, _g133, _path143, _g134, _path144, _g135, _path145, _g136, _path146, _g137, _path147, _g138, _path148, _g139, _path149, _g140, _path150, _g141, _path151, _g142, _path152, _g143, _path153, _g144, _path154, _g145, _path155, _g146, _path156, _g147, _path157, _g148, _path158, _g149, _path159, _g150, _path160, _g151, _path161, _g152, _path162, _g153, _path163, _g154, _path164, _g155, _path165, _g156, _path166, _g157, _path167, _g158, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPop1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 200,
    viewBox: "0 0 388 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 200,
    fill: "#FFEED4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1136_2092)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "#FFEED4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.952 98.1604L158.648 100.984L144.4 35.5204L156.7 32.6924L170.952 98.1604Z",
    fill: "#FF7550"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.4 35.5198C144.4 35.5198 145.088 37.2598 146.476 37.0318C147.864 36.8038 148.948 35.0518 148.948 35.0518C148.948 35.0518 149.696 36.4078 151.504 36.2438C153.308 36.0798 153.872 34.1518 153.872 34.1518C153.872 34.1518 154.608 35.3758 155.536 35.3438C156.464 35.3118 156.704 32.6958 156.704 32.6958L150.44 22.0598C149.868 21.0918 148.6 20.7998 147.664 21.4198C147.224 21.7118 146.92 22.1718 146.82 22.6918L144.4 35.5198Z",
    fill: "#FFBFA8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.524 25.5995L145.38 30.3115L146.816 22.6915C146.912 22.1715 147.22 21.7115 147.66 21.4235C148.596 20.7995 149.868 21.0915 150.436 22.0635L152.524 25.5995Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.46 99.7636C161.636 91.4076 159.808 83.0516 157.984 74.6956C156.156 66.3396 154.332 57.9836 152.508 49.6276L149.412 35.4675C149.304 34.9755 148.548 35.1836 148.656 35.6756C150.484 44.0316 152.308 52.3876 154.132 60.7436C155.956 69.0996 157.784 77.4556 159.608 85.8116L162.7 99.9715C162.812 100.468 163.568 100.256 163.46 99.7636Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.796 97.7678L163.832 73.2558C161.844 65.0838 159.856 56.9158 157.872 48.7438C156.748 44.1198 155.624 39.4958 154.5 34.8718C154.38 34.3798 153.624 34.5878 153.744 35.0798C155.732 43.2518 157.72 51.4198 159.704 59.5918L165.664 84.1038C166.788 88.7278 167.912 93.3518 169.036 97.9758C169.16 98.4678 169.916 98.2598 169.796 97.7678Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.952 105.876L155.124 102.812L167.076 36.4717L180.9 39.5357L168.952 105.876Z",
    fill: "#60BFB2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.076 36.4723C167.076 36.4723 167.076 38.3803 168.596 38.8083C170.116 39.2363 171.948 38.1323 171.948 38.1323C171.948 38.1323 172.168 39.7123 174.096 40.3923C176.024 41.0723 177.388 39.5683 177.388 39.5683C177.388 39.5683 177.648 41.0243 178.62 41.4203C179.588 41.8163 180.9 39.5363 180.9 39.5363L178.776 26.9483C178.58 25.8003 177.396 24.9523 176.176 25.0923C175.604 25.1563 175.104 25.4363 174.792 25.8643L167.076 36.4723Z",
    fill: "#FFBFA8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.484 31.1363L172.176 29.4563L174.788 25.8643C175.1 25.4323 175.6 25.1523 176.172 25.0923C177.392 24.9523 178.58 25.8003 178.772 26.9483L179.484 31.1363Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.132 38.7681C169.448 46.9361 167.764 55.1041 166.08 63.2721C164.396 71.4401 162.712 79.6081 161.028 87.7801C160.08 92.3761 159.136 96.9681 158.188 101.564C158.088 102.056 158.844 102.268 158.944 101.772C160.628 93.6041 162.312 85.4361 163.996 77.2681C165.68 69.1001 167.364 60.9321 169.048 52.7641C169.996 48.1681 170.94 43.5761 171.888 38.9801C171.992 38.4841 171.236 38.2761 171.132 38.7681Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.864 40.2156C175.124 48.3116 173.388 56.4076 171.652 64.5036C169.92 72.5676 168.192 80.6316 166.46 88.6956L163.524 102.368C163.42 102.86 164.176 103.072 164.28 102.576C166.016 94.4796 167.756 86.3836 169.492 78.2876C171.224 70.2236 172.952 62.1596 174.684 54.0956C175.664 49.5396 176.64 44.9796 177.62 40.4236C177.728 39.9316 176.972 39.7236 176.864 40.2156Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.496 26.4561C284.496 26.4561 246.928 49.7441 260.256 100.348C260.256 100.352 301.588 71.3401 284.496 26.4561Z",
    fill: "#60BFB2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.54 74.84C271.988 77.976 268.44 81.1119 264.888 84.2479C266.328 79.5319 267.816 74.828 269.364 70.144C269.568 69.52 269.784 68.9 269.988 68.2799C269.996 68.2719 270.008 68.2679 270.016 68.2599C273.88 64.82 277.744 61.3759 281.604 57.9359C281.968 57.6119 281.468 57.0519 281.104 57.3719C277.56 60.5319 274.012 63.688 270.464 66.8479C272.464 60.8919 274.552 54.96 276.72 49.064C276.744 49.052 276.764 49.04 276.788 49.02C279.464 46.748 282.144 44.4759 284.82 42.1999C285.192 41.8839 284.688 41.3239 284.32 41.6359C281.96 43.6359 279.604 45.6399 277.244 47.6399C277.592 46.6999 277.936 45.76 278.288 44.82C280.056 40.12 281.876 35.4399 283.748 30.7839C283.928 30.3359 283.212 30.0999 283.032 30.5479C280.8 36.0999 278.652 41.684 276.572 47.292C275.924 44.624 275.276 41.9599 274.624 39.2919C274.512 38.8199 273.772 38.9759 273.888 39.4519C274.624 42.4839 275.364 45.516 276.1 48.548C275.24 50.884 274.388 53.2239 273.556 55.5679C272.264 59.1999 271.012 62.84 269.784 66.492L266.788 54.2999C266.672 53.832 265.936 53.9839 266.052 54.4599C267.144 58.9119 268.24 63.368 269.336 67.82C267.868 72.212 266.448 76.62 265.072 81.04C264.784 81.964 264.5 82.8919 264.22 83.8159C263.492 79.8719 262.764 75.928 262.036 71.984C261.948 71.508 261.212 71.664 261.3 72.144C262.116 76.556 262.928 80.972 263.74 85.384C262.724 88.74 261.732 92.104 260.768 95.476C260.636 95.9399 261.348 96.1759 261.484 95.712C262.448 92.34 263.448 88.976 264.464 85.6199C268.32 82.216 272.176 78.812 276.032 75.4039C276.404 75.0799 275.904 74.52 275.54 74.84Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.2 48.98C317.2 48.98 269.1 45.888 259.16 100.74C259.16 100.736 313.628 101.048 317.2 48.98Z",
    fill: "#FFB533"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.056 99.2283L271.636 92.3843C277.632 91.7363 283.628 91.0883 289.628 90.4363C290.108 90.3843 290.064 89.6323 289.584 89.6843C283.92 90.2963 278.256 90.9123 272.592 91.5243C276.28 88.1923 279.968 84.8643 283.66 81.5323C284.376 80.8843 285.096 80.2363 285.816 79.5883C291.124 78.9483 296.432 78.3123 301.74 77.6723C302.22 77.6163 302.176 76.8643 301.696 76.9203C296.724 77.5163 291.756 78.1163 286.784 78.7163C291.652 74.3203 296.524 69.9243 301.392 65.5243C301.436 65.5403 301.48 65.5523 301.532 65.5483C304.732 65.2803 307.932 65.0123 311.136 64.7403C311.62 64.7003 311.572 63.9483 311.092 63.9883C308.152 64.2363 305.216 64.4803 302.276 64.7283L303.26 63.8403C306.932 60.5243 310.608 57.2083 314.28 53.8923C314.64 53.5683 314.064 53.0803 313.708 53.4003C309.828 56.9043 305.948 60.4083 302.068 63.9123C302.476 61.0283 302.88 58.1483 303.288 55.2643C303.356 54.7843 302.616 54.6363 302.548 55.1163C302.096 58.3083 301.648 61.5043 301.196 64.6963C298.832 66.8283 296.472 68.9603 294.108 71.0923L286.252 78.1843L288.544 63.7603C288.62 63.2803 287.884 63.1323 287.804 63.6123C286.992 68.7363 286.176 73.8643 285.364 78.9883L274.512 88.7883C273.676 89.5443 272.84 90.2963 272.004 91.0523C272.82 86.7123 273.636 82.3723 274.452 78.0323C274.54 77.5563 273.804 77.4083 273.712 77.8843C272.836 82.5523 271.956 87.2203 271.08 91.8883C268.552 94.1723 266.02 96.4563 263.492 98.7403C263.128 99.0603 263.7 99.5523 264.056 99.2283Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.408 51.5078C80.408 51.5078 87.728 93.6118 137.924 99.9318C137.924 99.9318 126.832 52.3878 80.408 51.5078Z",
    fill: "#60BFB2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.564 77.0118C122.092 81.3278 123.624 85.6478 125.156 89.9638C121.444 86.9678 117.764 83.9358 114.124 80.8558C113.64 80.4478 113.16 80.0318 112.676 79.6198C112.672 79.6078 112.672 79.5998 112.668 79.5878C110.976 74.8798 109.288 70.1718 107.596 65.4678C107.436 65.0278 106.752 65.2718 106.912 65.7118C108.464 70.0318 110.016 74.3518 111.568 78.6718C106.948 74.7238 102.384 70.7118 97.8761 66.6398C97.8721 66.6158 97.8681 66.5918 97.8601 66.5638C96.7881 63.3438 95.7161 60.1198 94.6481 56.8958C94.5001 56.4518 93.8161 56.6958 93.9641 57.1398C94.9081 59.9758 95.8521 62.8158 96.7961 65.6518C96.0801 64.9998 95.3601 64.3518 94.6441 63.6958C91.0681 60.4158 87.5281 57.0918 84.0281 53.7318C83.6881 53.4078 83.2241 53.9638 83.5601 54.2878C87.7321 58.2918 91.9641 62.2398 96.2441 66.1278C93.6201 65.7478 90.9921 65.3638 88.3681 64.9838C87.9041 64.9158 87.7801 65.6318 88.2441 65.6998C91.2281 66.1318 94.2161 66.5678 97.2001 66.9998C98.9841 68.6158 100.772 70.2238 102.576 71.8198C105.364 74.2878 108.18 76.7278 111.012 79.1478C107.008 78.5758 103 78.0038 98.9961 77.4318C98.5321 77.3638 98.4081 78.0838 98.8721 78.1478C103.26 78.7758 107.652 79.4038 112.04 80.0278C115.448 82.9278 118.888 85.7958 122.356 88.6238C123.08 89.2158 123.808 89.8038 124.536 90.3918C120.736 89.6198 116.936 88.8478 113.136 88.0758C112.676 87.9838 112.552 88.6998 113.012 88.7918C117.264 89.6558 121.516 90.5198 125.768 91.3838C128.412 93.5078 131.068 95.6118 133.744 97.6958C134.112 97.9838 134.584 97.4278 134.212 97.1398C131.536 95.0558 128.88 92.9438 126.236 90.8198C124.576 86.1318 122.912 81.4438 121.252 76.7598C121.092 76.3238 120.408 76.5678 120.564 77.0118Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.416 30.3076C112.416 30.3076 92.272 72.3276 137.876 101.052C137.876 101.056 157.824 52.3156 112.416 30.3076Z",
    fill: "#FFB533"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.292 96.1156C137.16 93.0276 136.024 89.9356 134.892 86.8476C136.476 81.2356 138.06 75.6236 139.644 70.0076C139.772 69.5556 139.08 69.3276 138.952 69.7756L134.464 85.6796L129.5 72.1476C129.18 71.2676 128.856 70.3916 128.532 69.5156C129.876 64.5236 131.22 59.5316 132.564 54.5396C132.684 54.0876 131.996 53.8556 131.872 54.3076L128.096 68.3276C125.912 62.3716 123.728 56.4156 121.544 50.4596C121.572 50.4276 121.6 50.3916 121.616 50.3436C122.532 47.3756 123.448 44.4076 124.36 41.4396C124.5 40.9916 123.808 40.7596 123.668 41.2076C122.828 43.9316 121.988 46.6556 121.148 49.3796C121 48.9756 120.852 48.5756 120.708 48.1756C119.06 43.6836 117.412 39.1916 115.764 34.6996C115.604 34.2596 114.956 34.5996 115.116 35.0316C116.856 39.7756 118.596 44.5236 120.34 49.2676C117.9 47.8596 115.464 46.4556 113.024 45.0516C112.62 44.8196 112.216 45.4236 112.624 45.6596C115.324 47.2156 118.028 48.7756 120.728 50.3316C121.788 53.2196 122.848 56.1076 123.908 58.9956C125.084 62.1996 126.256 65.3996 127.432 68.6036C123.396 66.1836 119.36 63.7596 115.324 61.3396C114.924 61.0996 114.52 61.7076 114.924 61.9476C119.228 64.5276 123.528 67.1076 127.832 69.6916C129.456 74.1156 131.076 78.5396 132.7 82.9636C133.076 83.9876 133.452 85.0076 133.824 86.0316C130.228 83.7316 126.628 81.4356 123.028 79.1356C122.632 78.8836 122.232 79.4916 122.628 79.7436L134.236 87.1596C135.372 90.2516 136.504 93.3476 137.64 96.4396C137.804 96.8876 138.452 96.5516 138.292 96.1156Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7961 76.3564C66.7921 76.3564 66.7881 76.3564 66.7801 76.3564C66.5641 76.3484 66.3961 76.1684 66.4041 75.9524C66.4241 75.4244 66.4521 74.9004 66.4841 74.3724C66.5001 74.1564 66.6881 73.9964 66.9001 74.0084C67.1161 74.0244 67.2801 74.2084 67.2681 74.4244C67.2361 74.9444 67.2081 75.4604 67.1881 75.9804C67.1801 76.1924 67.0041 76.3564 66.7961 76.3564Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1599 71.7357C67.1439 71.7357 67.1279 71.7357 67.1119 71.7317C66.8959 71.7037 66.7439 71.5117 66.7719 71.2957C66.8959 70.2797 67.0479 69.2557 67.2319 68.2397C67.2719 68.0277 67.4719 67.8837 67.6879 67.9237C67.8999 67.9637 68.0439 68.1637 68.0039 68.3797C67.8279 69.3757 67.6719 70.3917 67.5519 71.3917C67.5279 71.5877 67.3559 71.7357 67.1599 71.7357Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4161 64.9516C68.3841 64.9516 68.3521 64.9476 68.3201 64.9396C68.1121 64.8876 67.9801 64.6756 68.0361 64.4636C68.2841 63.4716 68.5601 62.4716 68.8641 61.4876C68.9281 61.2796 69.1481 61.1636 69.3521 61.2276C69.5601 61.2916 69.6761 61.5116 69.6121 61.7156C69.3161 62.6876 69.0401 63.6716 68.7961 64.6516C68.7521 64.8316 68.5921 64.9516 68.4161 64.9516ZM70.2161 59.0876C70.1721 59.0876 70.1241 59.0796 70.0801 59.0636C69.8761 58.9876 69.7721 58.7636 69.8481 58.5596C70.2001 57.5996 70.5801 56.6316 70.9841 55.6876C71.0681 55.4876 71.3001 55.3956 71.5001 55.4796C71.7001 55.5636 71.7921 55.7956 71.7081 55.9956C71.3121 56.9276 70.9361 57.8796 70.5881 58.8276C70.5241 58.9916 70.3721 59.0876 70.2161 59.0876ZM72.9561 52.7596C72.8961 52.7596 72.8361 52.7476 72.7801 52.7156C72.5881 52.6196 72.5081 52.3836 72.6081 52.1876C73.0681 51.2716 73.5601 50.3596 74.0681 49.4676C74.1761 49.2796 74.4161 49.2156 74.6041 49.3236C74.7921 49.4316 74.8561 49.6716 74.7481 49.8596C74.2481 50.7396 73.7601 51.6396 73.3041 52.5436C73.2401 52.6796 73.1001 52.7596 72.9561 52.7596ZM76.0001 47.4356C75.9281 47.4356 75.8521 47.4156 75.7881 47.3756C75.6041 47.2596 75.5521 47.0156 75.6721 46.8356C76.2241 45.9716 76.8121 45.1156 77.4081 44.2836C77.5361 44.1076 77.7801 44.0676 77.9561 44.1956C78.1321 44.3236 78.1721 44.5676 78.0441 44.7436C77.4521 45.5636 76.8761 46.4116 76.3321 47.2636C76.2561 47.3716 76.1281 47.4356 76.0001 47.4356ZM80.0681 41.8636C79.9801 41.8636 79.8921 41.8356 79.8201 41.7756C79.6521 41.6396 79.6281 41.3916 79.7681 41.2236C80.4201 40.4316 81.1041 39.6476 81.7961 38.8956C81.9441 38.7356 82.1881 38.7236 82.3481 38.8716C82.5081 39.0196 82.5201 39.2676 82.3721 39.4276C81.6881 40.1716 81.0161 40.9476 80.3721 41.7276C80.2921 41.8116 80.1801 41.8636 80.0681 41.8636ZM84.2121 37.3436C84.1121 37.3436 84.0081 37.3036 83.9321 37.2276C83.7801 37.0716 83.7841 36.8236 83.9401 36.6716C84.6721 35.9556 85.4361 35.2476 86.2081 34.5756C86.3681 34.4316 86.6201 34.4476 86.7601 34.6116C86.9041 34.7756 86.8881 35.0236 86.7241 35.1636C85.9641 35.8276 85.2121 36.5236 84.4881 37.2316C84.4121 37.3076 84.3121 37.3436 84.2121 37.3436ZM89.4361 32.8396C89.3161 32.8396 89.2001 32.7876 89.1241 32.6836C88.9921 32.5116 89.0281 32.2636 89.2001 32.1356C89.6121 31.8236 90.0281 31.5156 90.4481 31.2156C90.8641 30.9156 91.2881 30.6236 91.7121 30.3396C91.8921 30.2196 92.1361 30.2676 92.2561 30.4476C92.3761 30.6276 92.3281 30.8716 92.1481 30.9916C91.7281 31.2756 91.3121 31.5636 90.9001 31.8556C90.4841 32.1516 90.0761 32.4556 89.6721 32.7636C89.6001 32.8116 89.5201 32.8396 89.4361 32.8396ZM94.5241 29.4156C94.3921 29.4156 94.2601 29.3476 94.1881 29.2236C94.0761 29.0396 94.1401 28.7956 94.3241 28.6876C95.2041 28.1636 96.1121 27.6596 97.0241 27.1836C97.2161 27.0836 97.4521 27.1596 97.5521 27.3516C97.6521 27.5436 97.5801 27.7796 97.3881 27.8796C96.4921 28.3476 95.5961 28.8476 94.7281 29.3636C94.6601 29.3956 94.5921 29.4156 94.5241 29.4156ZM100.66 26.2636C100.508 26.2636 100.364 26.1756 100.3 26.0276C100.212 25.8276 100.304 25.5996 100.5 25.5116C101.436 25.0996 102.4 24.7076 103.36 24.3476C103.564 24.2716 103.788 24.3756 103.864 24.5756C103.94 24.7796 103.836 25.0036 103.636 25.0796C102.688 25.4356 101.74 25.8236 100.816 26.2276C100.764 26.2516 100.712 26.2636 100.66 26.2636ZM106.396 24.0996C106.232 24.0996 106.076 23.9916 106.024 23.8276C105.96 23.6196 106.072 23.3996 106.28 23.3356C107.252 23.0276 108.252 22.7396 109.248 22.4796C109.46 22.4236 109.672 22.5516 109.728 22.7596C109.784 22.9676 109.656 23.1836 109.448 23.2396C108.468 23.4956 107.48 23.7796 106.52 24.0836C106.476 24.0956 106.436 24.0996 106.396 24.0996ZM113.084 22.4036C112.9 22.4036 112.736 22.2716 112.7 22.0836C112.66 21.8716 112.8 21.6676 113.012 21.6236C114.016 21.4316 115.04 21.2596 116.06 21.1196C116.272 21.0876 116.472 21.2396 116.5 21.4516C116.528 21.6676 116.38 21.8636 116.164 21.8956C115.16 22.0356 114.148 22.2036 113.156 22.3916C113.132 22.3996 113.108 22.4036 113.084 22.4036ZM135.192 22.3996C135.168 22.3996 135.14 22.3956 135.116 22.3916C134.128 22.1956 133.116 22.0276 132.112 21.8876C131.9 21.8556 131.748 21.6596 131.78 21.4436C131.812 21.2276 132.012 21.0756 132.224 21.1116C133.24 21.2556 134.268 21.4276 135.272 21.6236C135.484 21.6636 135.624 21.8716 135.58 22.0836C135.536 22.2716 135.372 22.3996 135.192 22.3996ZM119.16 21.5596C118.96 21.5596 118.788 21.4036 118.768 21.2036C118.748 20.9876 118.908 20.7996 119.124 20.7796C120.148 20.6916 121.184 20.6276 122.208 20.5956C122.436 20.5836 122.604 20.7556 122.612 20.9756C122.62 21.1916 122.452 21.3716 122.232 21.3796C121.224 21.4116 120.2 21.4756 119.192 21.5636C119.18 21.5596 119.168 21.5596 119.16 21.5596ZM129.116 21.5476C129.104 21.5476 129.092 21.5476 129.084 21.5476C128.08 21.4636 127.056 21.4036 126.044 21.3676C125.828 21.3596 125.656 21.1796 125.664 20.9636C125.672 20.7476 125.86 20.5716 126.068 20.5836C127.096 20.6156 128.132 20.6756 129.152 20.7636C129.368 20.7836 129.528 20.9716 129.508 21.1876C129.488 21.3956 129.32 21.5476 129.116 21.5476Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.444 23.7076C140.408 23.7076 140.368 23.7036 140.332 23.6916C139.836 23.5396 139.336 23.3996 138.836 23.2636C138.628 23.2076 138.504 22.9916 138.56 22.7836C138.616 22.5756 138.832 22.4516 139.04 22.5076C139.548 22.6436 140.056 22.7916 140.56 22.9436C140.768 23.0076 140.884 23.2236 140.82 23.4316C140.768 23.5956 140.612 23.7076 140.444 23.7076Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.768 130.384C319.62 130.384 319.48 130.3 319.412 130.16C319.192 129.688 318.96 129.22 318.724 128.768C318.624 128.576 318.7 128.34 318.892 128.24C319.084 128.14 319.32 128.216 319.42 128.408C319.66 128.868 319.896 129.348 320.124 129.828C320.216 130.024 320.132 130.256 319.936 130.348C319.88 130.372 319.824 130.384 319.768 130.384Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.108 136.68C321.936 136.68 321.78 136.568 321.732 136.392C321.432 135.324 321.088 134.256 320.704 133.224C320.628 133.02 320.732 132.796 320.936 132.72C321.14 132.644 321.364 132.748 321.44 132.952C321.832 134.004 322.184 135.092 322.488 136.18C322.548 136.388 322.424 136.604 322.216 136.664C322.18 136.676 322.144 136.68 322.108 136.68Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.656 184.772C300.512 184.772 300.372 184.692 300.304 184.552C300.208 184.356 300.288 184.124 300.48 184.028C301.468 183.54 302.452 183.004 303.404 182.432C303.588 182.32 303.832 182.38 303.94 182.568C304.052 182.752 303.992 182.996 303.804 183.104C302.832 183.688 301.832 184.236 300.824 184.732C300.776 184.76 300.716 184.772 300.656 184.772ZM306.42 181.316C306.3 181.316 306.176 181.26 306.1 181.152C305.976 180.976 306.016 180.732 306.192 180.604C307.088 179.96 307.976 179.272 308.82 178.56C308.984 178.42 309.232 178.44 309.372 178.608C309.512 178.772 309.492 179.02 309.324 179.16C308.464 179.888 307.56 180.588 306.644 181.244C306.576 181.292 306.496 181.316 306.42 181.316ZM312.144 176.388C312.044 176.388 311.948 176.352 311.872 176.276C311.716 176.124 311.712 175.876 311.864 175.72C312.632 174.928 313.38 174.092 314.084 173.24C314.22 173.072 314.468 173.048 314.636 173.188C314.804 173.328 314.828 173.572 314.688 173.74C313.972 174.608 313.208 175.46 312.424 176.268C312.348 176.348 312.244 176.388 312.144 176.388ZM316.42 171.204C316.344 171.204 316.264 171.18 316.196 171.132C316.016 171.008 315.976 170.764 316.1 170.588C316.736 169.68 317.34 168.732 317.892 167.784C318 167.596 318.24 167.532 318.428 167.644C318.616 167.752 318.68 167.992 318.568 168.18C318.004 169.152 317.388 170.112 316.74 171.04C316.664 171.148 316.544 171.204 316.42 171.204ZM320.148 164.636C320.096 164.636 320.04 164.624 319.988 164.6C319.792 164.512 319.7 164.28 319.792 164.08C319.96 163.7 320.124 163.32 320.284 162.932C320.544 162.296 320.792 161.64 321.02 160.984C321.092 160.78 321.316 160.672 321.52 160.744C321.724 160.816 321.832 161.04 321.76 161.244C321.528 161.912 321.272 162.58 321.008 163.232C320.848 163.624 320.68 164.012 320.508 164.4C320.444 164.548 320.3 164.636 320.148 164.636ZM322.36 158.292C322.328 158.292 322.296 158.288 322.264 158.28C322.052 158.224 321.928 158.012 321.98 157.804C322.252 156.736 322.488 155.64 322.672 154.548C322.708 154.336 322.912 154.192 323.124 154.228C323.336 154.264 323.48 154.468 323.444 154.68C323.256 155.796 323.016 156.912 322.736 158C322.696 158.176 322.536 158.292 322.36 158.292ZM323.556 150.832C323.548 150.832 323.54 150.832 323.528 150.832C323.312 150.816 323.148 150.628 323.164 150.416C323.228 149.48 323.26 148.532 323.26 147.596C323.26 147.428 323.26 147.256 323.256 147.088C323.252 146.872 323.428 146.692 323.644 146.692H323.648C323.864 146.692 324.04 146.864 324.04 147.08C324.044 147.252 324.044 147.424 324.044 147.596C324.044 148.548 324.012 149.516 323.948 150.468C323.932 150.672 323.76 150.832 323.556 150.832ZM323.472 144.112C323.272 144.112 323.1 143.96 323.08 143.756C322.98 142.656 322.832 141.544 322.644 140.456C322.608 140.244 322.748 140.04 322.964 140.004C323.18 139.968 323.38 140.108 323.416 140.324C323.608 141.432 323.756 142.564 323.86 143.688C323.88 143.904 323.72 144.096 323.504 144.116C323.496 144.112 323.484 144.112 323.472 144.112Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.312 186.948C295.144 186.948 294.992 186.84 294.94 186.676C294.872 186.472 294.988 186.248 295.192 186.184C295.684 186.024 296.176 185.856 296.66 185.676C296.864 185.6 297.088 185.704 297.164 185.908C297.24 186.112 297.136 186.336 296.932 186.412C296.44 186.592 295.936 186.768 295.436 186.928C295.392 186.94 295.352 186.948 295.312 186.948Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9279 170.1C83.7479 170.1 83.5879 169.976 83.5439 169.796C83.4279 169.276 83.3279 168.748 83.2519 168.224C83.2199 168.012 83.3679 167.812 83.5839 167.78C83.7959 167.744 83.9959 167.896 84.0279 168.112C84.0999 168.616 84.1959 169.124 84.3119 169.624C84.3599 169.836 84.2279 170.044 84.0159 170.092C83.9839 170.096 83.9559 170.1 83.9279 170.1Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.212 175.988C86.076 175.988 85.94 175.916 85.868 175.788C85.34 174.848 84.876 173.868 84.488 172.876C84.408 172.676 84.508 172.448 84.712 172.368C84.912 172.288 85.14 172.388 85.22 172.592C85.592 173.548 86.04 174.496 86.552 175.404C86.656 175.592 86.592 175.832 86.4 175.936C86.344 175.972 86.276 175.988 86.212 175.988Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7359 185.252C95.6759 185.252 95.6119 185.236 95.5559 185.208C94.6119 184.716 93.6919 184.148 92.8119 183.52C92.6359 183.392 92.5959 183.148 92.7199 182.972C92.8439 182.796 93.0919 182.756 93.2679 182.88C94.1159 183.488 95.0079 184.036 95.9199 184.508C96.1119 184.608 96.1879 184.844 96.0879 185.036C96.0119 185.176 95.8759 185.252 95.7359 185.252ZM90.5919 181.58C90.4959 181.58 90.3999 181.544 90.3239 181.472C89.5439 180.74 88.8079 179.944 88.1319 179.112C87.9959 178.944 88.0199 178.696 88.1879 178.56C88.3559 178.424 88.6039 178.448 88.7399 178.616C89.3919 179.42 90.1039 180.188 90.8599 180.9C91.0159 181.048 91.0239 181.296 90.8759 181.452C90.7999 181.54 90.6959 181.58 90.5919 181.58Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.912 187.156C100.884 187.156 100.856 187.152 100.824 187.148C100.308 187.032 99.7839 186.896 99.2759 186.74C99.0679 186.676 98.9519 186.456 99.0159 186.252C99.0799 186.048 99.2999 185.928 99.5039 185.992C99.9919 186.14 100.492 186.272 100.992 186.384C101.204 186.432 101.336 186.64 101.288 186.852C101.252 187.032 101.092 187.156 100.912 187.156Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.152 169.26L290.636 200H239.812L252.904 157.864L289.152 169.26Z",
    fill: "#60BFB2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.216 181.16C284.148 180.664 283.392 180.876 283.46 181.368C284.072 185.868 284.684 195.128 285.296 199.628C285.364 200.124 286.12 199.912 286.052 199.42C285.44 194.92 284.828 185.66 284.216 181.16Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.996 141.34C302.584 144.936 301.424 148.424 300.46 151.896C299.44 155.544 298.42 159.2 297.408 162.852C296.52 166.04 295.752 169.352 294.152 172.276C292.628 175.06 290.26 177.08 287.532 178.636C286.188 179.4 284.788 180.06 283.38 180.7C281.804 181.42 280.224 182.144 278.592 182.744C275.444 183.904 272.076 184.516 268.776 183.628C262.312 181.876 258.3 176.056 255.112 170.584C253.46 167.744 251.552 164.792 251.184 161.456C250.804 157.996 252.472 154.768 253.892 151.732C255.504 148.292 257.12 144.848 258.728 141.412C260.252 138.156 261.72 134.86 263.356 131.656C266.192 126.116 270.252 120.536 276.572 118.832C279.736 117.976 282.952 118.488 285.932 119.748C288.924 121.012 291.744 122.828 294.28 124.852C295.876 126.124 297.364 127.584 298.652 129.2C299.556 130.084 300.388 131.044 301.084 132.112C302.872 134.868 303.368 138.1 302.996 141.34Z",
    fill: "#FFB533"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.688 173.844C284.044 175.884 281.172 177.62 278.124 178.988C276.564 179.692 274.9 180.38 273.168 180.452C271.608 180.516 270.16 179.984 268.868 179.136C267.456 178.208 266.264 176.98 265.104 175.76C264.756 175.392 264.2 175.948 264.548 176.316C266.616 178.488 268.972 180.844 272.104 181.2C273.884 181.404 275.648 180.868 277.276 180.2C278.924 179.524 280.524 178.74 282.072 177.86C283.82 176.868 285.492 175.748 287.08 174.52C287.476 174.216 287.084 173.532 286.688 173.844Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.88 149.38C300.196 150.24 299.504 151.084 298.792 151.92C297.952 152.912 297.092 153.888 296.208 154.844C295.336 155.8 294.444 156.736 293.532 157.656C292.612 158.584 291.668 159.496 290.708 160.384C290.048 161.004 289.384 161.612 288.704 162.208C288.596 162.304 288.476 162.316 288.368 162.3C288.284 162.32 288.188 162.316 288.088 162.256C286.92 161.576 285.792 160.836 284.704 160.032C284.4 159.808 284.096 159.576 283.796 159.34C279.152 155.696 275.388 150.94 272.92 145.576C272.792 145.304 272.668 145.032 272.552 144.756C272.44 144.504 272.596 144.276 272.792 144.192C273.108 143.688 273.436 143.184 273.776 142.696C274.54 141.584 275.368 140.508 276.248 139.48C276.34 139.368 276.44 139.256 276.536 139.144C277.048 138.56 277.58 137.996 278.128 137.448C279.044 136.52 280.004 135.644 281.012 134.82C282.396 133.684 283.856 132.64 285.384 131.712C288.804 129.628 293.04 127.896 296.94 129.768C297.396 129.988 296.996 130.66 296.544 130.444C294.456 129.436 292.044 129.616 289.9 130.352C288.072 130.98 286.372 131.98 284.76 133.032C283.636 133.768 282.552 134.568 281.516 135.424C281.128 135.74 280.752 136.064 280.38 136.396C279.776 136.932 279.192 137.488 278.628 138.06C277.968 138.728 277.336 139.42 276.732 140.132C275.86 141.16 275.04 142.232 274.28 143.352C273.976 143.804 273.676 144.256 273.392 144.72C273.46 144.872 273.528 145.02 273.596 145.176C274.192 146.468 274.86 147.736 275.604 148.956C278.116 153.068 281.432 156.668 285.316 159.504C286.288 160.216 287.3 160.88 288.34 161.492C288.936 160.964 289.524 160.428 290.108 159.888C291.068 158.996 292.008 158.084 292.928 157.156C293.832 156.248 294.72 155.316 295.588 154.372C296.472 153.416 297.332 152.444 298.172 151.452C298.904 150.592 299.628 149.72 300.328 148.832C300.64 148.432 301.192 148.988 300.88 149.38Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.708 160.032C278.02 165.696 264.324 167.232 264.324 167.232L258.496 154.3L272.92 145.576C275.388 150.94 279.152 155.692 283.8 159.34C284.1 159.576 284.4 159.808 284.708 160.032Z",
    fill: "#EF997B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.924 157.152C292.004 158.08 291.064 158.992 290.1 159.884C284.224 154.972 278.932 149.424 274.276 143.348C275.036 142.232 275.856 141.156 276.732 140.128C281.44 146.42 286.884 152.124 292.924 157.152Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.168 151.448C297.328 152.44 296.468 153.412 295.584 154.368C289.352 149.556 283.668 144.116 278.624 138.056C279.188 137.484 279.772 136.932 280.376 136.396C280.748 136.064 281.124 135.74 281.512 135.424C286.46 141.356 292.028 146.752 298.168 151.448Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.172 122.316L292.376 125.3C292.376 125.3 284.248 127.396 282.592 119.452L284.72 117.652L293.172 122.316Z",
    fill: "#F27A51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.748 103.4C272.828 103.7 272.916 104.008 273.016 104.312C275.22 111.132 281.976 116.608 290.552 121.028C303.22 127.56 315.464 129.528 322.924 119.204C326.808 121.08 331.7 119.984 334.608 116.336C337.968 112.124 337.412 106.1 333.376 102.872C331.916 101.708 330.196 101.064 328.444 100.928C328.544 90.1164 323.868 79.2604 314.564 74.4644C305.3 69.6844 293.78 72.1324 285.044 78.4404C285.044 78.4404 276.216 84.7204 273.208 93.5684C273.228 93.5804 273.248 93.5884 273.268 93.6004C272.068 97.1364 271.968 100.396 272.748 103.4Z",
    fill: "#EF997B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.684 126.16C316.128 125.356 321.036 122.124 323.896 117.416C324.764 115.984 325.44 114.448 325.9 112.836C326.008 112.456 326.616 112.58 326.508 112.964C324.872 118.656 320.684 123.344 315.196 125.568C313.756 126.152 312.252 126.548 310.72 126.776C310.324 126.836 310.296 126.216 310.684 126.16Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.476 110.112C331.4 109.104 332.58 107.912 334.064 107.988C334.764 108.024 335.448 108.368 335.756 109.02C336.036 109.612 335.984 110.324 335.52 110.808C335.244 111.096 334.788 110.676 335.064 110.388C335.4 110.036 335.376 109.488 335.092 109.108C334.776 108.676 334.18 108.56 333.68 108.624C332.556 108.76 331.656 109.752 330.932 110.54C330.104 111.44 329.388 112.444 328.868 113.548C328.432 114.464 327.756 115.956 328.384 116.92C328.732 117.46 329.36 117.496 329.88 117.192C330.484 116.84 330.788 116.136 331.072 115.528C331.24 115.164 331.792 115.452 331.624 115.812C331.108 116.924 330.108 118.476 328.636 117.908C327.152 117.332 327.492 115.44 327.9 114.28C328.444 112.716 329.364 111.32 330.476 110.112Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.656 108.332C306.416 110.732 307.36 113.68 309.76 114.92C312.16 116.156 315.112 115.216 316.348 112.816C317.588 110.416 316.644 107.468 314.244 106.228C311.844 104.988 308.896 105.932 307.656 108.332Z",
    fill: "#F27A51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.64 92.3357C275.4 94.7357 276.344 97.6877 278.744 98.9237C281.144 100.164 284.096 99.2197 285.332 96.8197C286.572 94.4197 285.628 91.4677 283.228 90.2317C280.828 88.9957 277.876 89.9357 276.64 92.3357Z",
    fill: "#F27A51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.276 100.412C305.44 102.032 305.824 103.888 307.136 104.564C308.444 105.24 310.18 104.476 311.016 102.856C311.852 101.24 311.468 99.3796 310.156 98.7036C308.848 98.0276 307.112 98.7956 306.276 100.412Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.268 91.1235C287.432 92.7395 287.816 94.5995 289.124 95.2755C290.432 95.9515 292.168 95.1835 293.004 93.5675C293.84 91.9515 293.456 90.0915 292.144 89.4155C290.84 88.7395 289.104 89.5075 288.268 91.1235Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.024 94.8316C310.124 94.6516 310.28 94.4836 310.48 94.4236C310.672 94.3636 310.932 94.3396 311.112 94.4596C311.848 94.9396 312.584 95.4196 313.32 95.8996C313.508 96.0196 313.652 96.1396 313.728 96.3556C313.796 96.5476 313.792 96.8076 313.692 96.9876C313.592 97.1676 313.436 97.3356 313.236 97.3956C313.04 97.4556 312.784 97.4756 312.604 97.3596C311.868 96.8796 311.132 96.3996 310.396 95.9196C310.212 95.7996 310.064 95.6796 309.988 95.4636C309.924 95.2756 309.928 95.0116 310.024 94.8316Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.984 85.1399C293.152 85.0359 293.396 84.9479 293.592 85.0119L295.708 85.7079C295.924 85.7799 296.096 85.8519 296.228 86.0479C296.34 86.2119 296.404 86.4599 296.356 86.6559C296.308 86.8599 296.2 87.0639 296.016 87.1799C295.848 87.2839 295.604 87.3719 295.408 87.3079C294.704 87.0759 294 86.8439 293.292 86.6119C293.076 86.5399 292.904 86.4679 292.772 86.2719C292.66 86.1079 292.596 85.8599 292.644 85.6639C292.692 85.4559 292.8 85.2559 292.984 85.1399Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.372 105.764C299.048 105.468 298.584 105.468 298.264 105.764C298.212 105.812 298.16 105.856 298.108 105.904C298.08 105.928 298.056 105.948 298.028 105.972C297.964 106.024 297.972 106.016 298.064 105.944C297.996 106.04 297.82 106.12 297.72 106.18C297.604 106.256 297.484 106.324 297.36 106.388C297.296 106.42 297.236 106.448 297.172 106.48C297.152 106.488 297.132 106.496 297.112 106.508C296.852 106.604 296.592 106.692 296.324 106.748C296.256 106.764 296.188 106.776 296.12 106.788C296.104 106.792 296.084 106.792 296.068 106.796C295.932 106.808 295.796 106.82 295.656 106.824C295.248 106.836 294.852 107.176 294.872 107.608C294.892 108.024 295.216 108.404 295.656 108.392C297.04 108.352 298.356 107.812 299.372 106.876C299.676 106.592 299.676 106.04 299.372 105.764Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.728 81.6802C329.556 80.4482 327.884 79.8082 326.208 79.8562C324.856 74.4162 320.352 70.1202 314.784 69.1482C313.572 68.9362 312.352 68.8842 311.136 68.9802C312.524 67.4242 313.62 65.6242 314.348 63.6602C315.204 61.3522 315.76 58.5202 314.428 56.2802C311.652 51.6202 305.176 55.4282 302.672 58.3922C301.852 59.3642 301.18 60.4362 300.676 61.5842C300.568 60.3482 300.588 59.0922 300.064 57.9402C299.404 56.5042 297.976 55.5482 296.396 56.1642C294.836 56.7762 293.696 58.4122 292.936 59.8362C292.14 61.3282 291.664 62.9802 291.508 64.6642C291.388 66.0042 291.488 67.3562 291.804 68.6602C289.904 67.1642 287.696 65.8882 285.212 66.5082C282.7 67.1362 281.568 69.7642 281.912 72.1682C282.304 74.8922 284.512 76.9082 286.724 78.3042C289.26 79.9082 292.112 81.0242 295.052 81.6202C297.032 82.0202 299.048 82.1802 301.056 82.1082C301.624 82.2002 302.196 82.2802 302.772 82.3362C302.12 82.6562 301.572 83.1362 301.256 83.8722C300.512 85.6002 301.96 87.1122 303.44 87.7642C305.288 88.5802 307.316 89.0962 309.272 89.5562C311.284 90.0282 313.324 90.3602 315.376 90.5722C317.428 90.7802 319.484 90.8442 321.544 90.7842C321.604 96.5202 323.344 102.184 326.528 106.948C326.64 107.108 326.804 107.152 326.952 107.116C327.116 107.324 327.544 107.34 327.664 107.004C329.284 102.552 330.58 97.9882 331.54 93.3482C332.292 89.7242 333.64 84.7322 330.728 81.6802ZM288.968 78.6802C286.768 77.5562 284.468 76.0842 283.28 73.8402C282.272 71.9402 282.336 69.0802 284.276 67.7682C285.496 66.9442 287.092 67.0162 288.424 67.5002C289.568 67.9162 290.564 68.6322 291.5 69.4082C289.828 68.5842 288.332 67.2642 286.324 67.6682C285.264 67.8842 284.484 68.6962 284.312 69.7562C284.112 70.9842 284.672 72.1162 285.404 73.0602C288.328 76.8682 292.656 79.6642 297.188 81.1642C294.332 80.8282 291.532 79.9922 288.968 78.6802ZM313.368 58.3442C311.528 54.4202 306.444 56.5162 303.964 58.5082C303.448 58.9202 302.972 59.3762 302.536 59.8642C303.732 58.1442 305.356 56.7202 307.248 55.8082C309.184 54.8762 311.82 54.2802 313.392 56.1642C314.984 58.0682 314.484 60.8482 313.756 63.0002C313.084 64.9882 312.008 66.8122 310.624 68.3762C312.02 65.1322 315.072 61.9762 313.368 58.3442Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.892 66.2804C325.744 65.8004 324.988 66.0044 325.136 66.4884C326.332 70.4404 326.888 74.5444 326.788 78.6724C326.776 79.1764 327.56 79.1764 327.572 78.6724C327.672 74.4804 327.104 70.2924 325.892 66.2804Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.464 74.9956C325.056 73.5196 324.648 72.0396 324.24 70.5596C324.108 70.0756 323.348 70.2796 323.484 70.7676C323.892 72.2436 324.3 73.7236 324.708 75.2036C324.844 75.6916 325.6 75.4836 325.464 74.9956Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.424 99.0204C298.048 101.236 296.372 103.212 293.956 102.848C292.836 102.676 291.848 102.04 291.072 101.236C290.376 100.52 289.444 99.4804 289.516 98.4124C289.596 97.1964 290.748 96.9644 291.74 96.8444C291.888 96.8244 292.04 96.8044 292.196 96.7884C292.852 96.6524 293.504 96.5164 294.16 96.3804C294.848 96.2364 295.528 96.0964 296.216 95.9524C296.728 95.8484 297.288 95.7004 297.78 95.9764C298.804 96.5604 298.588 98.0564 298.424 99.0204Z",
    fill: "#F27A51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.7 76.8116L224.536 79.8036C224.536 79.8036 230.864 80.0716 235.32 77.3596L233.9 75.0596L224.7 76.8116Z",
    fill: "#FF7550"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.408 55.8799C252.844 56.0919 252.276 56.2399 251.708 56.3319C251.84 68.6839 241.156 74.2079 227.508 76.4119C213.86 78.6199 201.976 76.7439 198.208 64.9759C194.06 65.5359 189.88 63.0519 188.3 58.8119C186.472 53.9159 188.8 48.5279 193.492 46.7679C195.188 46.1359 196.964 46.0599 198.628 46.4599C201.792 36.4639 209.376 27.8599 219.396 26.2399C229.38 24.6239 239.264 30.3559 245.416 38.7999C245.852 38.5479 246.308 38.3279 246.792 38.1439C251.484 36.3919 256.776 38.9399 258.604 43.8359C260.428 48.7399 258.104 54.1279 253.408 55.8799Z",
    fill: "#F78B66"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.396 75.0802C202.62 72.7002 199.068 68.2402 197.848 63.0402C197.48 61.4602 197.32 59.8362 197.38 58.2162C197.392 57.8322 196.796 57.7642 196.784 58.1522C196.576 63.8922 199.028 69.4762 203.416 73.1842C204.568 74.1562 205.832 74.9762 207.18 75.6482C207.528 75.8122 207.74 75.2522 207.396 75.0802Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.628 51.7156C251.148 49.8196 250.368 48.0236 249.324 46.3676C249.116 46.0396 248.656 46.4276 248.86 46.7516C252.352 52.2836 252.468 59.4796 249.144 65.1116C248.284 66.5716 247.216 67.9076 245.976 69.0676C245.696 69.3316 246.076 69.7956 246.36 69.5316C251.184 65.0196 253.256 58.1236 251.628 51.7156Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.26 47.0002C256.088 46.6562 255.54 46.9042 255.712 47.2522C256.2 48.2362 256.328 49.5522 255.384 50.3162C254.452 51.0722 253.424 50.5002 252.868 49.6082C251.84 47.9602 251.788 45.7082 252.368 43.9002C252.712 42.8162 253.292 41.8162 254.092 41.0042C254.36 40.7322 253.98 40.2642 253.708 40.5402C252.008 42.2722 251.188 44.7322 251.456 47.1402C251.58 48.2762 251.944 49.5122 252.696 50.3962C253.452 51.2842 254.64 51.5762 255.636 50.8802C256.912 49.9802 256.892 48.2722 256.26 47.0002Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.984 54.3198C193.436 53.1118 192.708 51.6558 191.316 51.2798C190.66 51.1038 189.928 51.2118 189.448 51.7198C189.012 52.1798 188.848 52.8558 189.128 53.4398C189.296 53.7878 189.844 53.5398 189.676 53.1878C189.472 52.7638 189.66 52.2638 190.036 51.9958C190.46 51.6918 191.04 51.7678 191.484 51.9718C192.48 52.4358 193.008 53.6198 193.44 54.5638C193.932 55.6438 194.288 56.7838 194.44 57.9598C194.564 58.9358 194.74 60.5118 193.868 61.2158C193.384 61.6078 192.796 61.4518 192.408 61.0158C191.956 60.5078 191.888 59.7678 191.808 59.1238C191.764 58.7398 191.168 58.8358 191.216 59.2198C191.356 60.3998 191.812 62.1318 193.34 62.0518C194.884 61.9678 195.136 60.1198 195.112 58.9278C195.072 57.3358 194.644 55.7718 193.984 54.3198Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.9 60.404C212.32 62.992 210.56 65.424 207.976 65.844C205.392 66.264 202.956 64.504 202.536 61.92C202.116 59.332 203.876 56.9 206.46 56.48C209.048 56.06 211.484 57.816 211.9 60.404Z",
    fill: "#E26240"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.32 54.9957C245.736 57.5837 243.98 60.0197 241.396 60.4357C238.808 60.8557 236.376 59.0957 235.956 56.5117C235.536 53.9277 237.296 51.4917 239.88 51.0717C242.464 50.6557 244.9 52.4117 245.32 54.9957Z",
    fill: "#E26240"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.56 53.5164C215.84 55.2604 214.928 56.8564 213.52 57.0844C212.112 57.3124 210.74 56.0844 210.456 54.3404C210.176 52.5964 211.088 51.0004 212.5 50.7724C213.904 50.5444 215.276 51.7724 215.56 53.5164Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.96 50.3796C235.24 52.1236 234.328 53.7196 232.92 53.9476C231.512 54.1756 230.14 52.9476 229.856 51.2036C229.576 49.4596 230.488 47.8636 231.9 47.6356C233.308 47.4076 234.68 48.6356 234.96 50.3796Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.012 57.3801C224.132 58.2441 223.784 59.0601 223.16 59.6481C222.472 60.3041 221.564 60.6121 220.636 60.7441C219.436 60.9121 216.452 61.2481 216.692 59.2121C216.792 58.3761 217.432 57.6001 217.952 56.9521C218.128 56.6881 218.32 56.4321 218.52 56.1841C218.976 55.6321 219.548 55.0161 220.192 54.5961C220.196 54.5881 220.2 54.5881 220.208 54.5841C220.212 54.5761 220.224 54.5721 220.228 54.5721C220.456 54.4241 220.696 54.3041 220.94 54.2161C221.78 53.9201 222.52 54.3121 223.004 54.9961C223.488 55.6801 223.896 56.5561 224.012 57.3801Z",
    fill: "#E26240"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.128 58.2563C227.668 58.2763 227.36 58.6083 227.328 59.0563C227.324 59.1243 227.316 59.1923 227.312 59.2563C227.312 59.2603 227.312 59.2603 227.312 59.2603C227.312 59.2723 227.308 59.2803 227.308 59.2923C227.288 59.4243 227.26 59.5563 227.228 59.6883C227.196 59.8203 227.16 59.9483 227.116 60.0763C227.096 60.1403 227.072 60.2043 227.048 60.2683C227.04 60.2963 227.028 60.3203 227.016 60.3483C226.904 60.5883 226.784 60.8243 226.64 61.0483C226.604 61.1043 226.564 61.1603 226.528 61.2163C226.508 61.2443 226.488 61.2723 226.468 61.3003C226.464 61.3043 226.46 61.3123 226.456 61.3203C226.448 61.3283 226.444 61.3363 226.44 61.3403C226.42 61.3643 226.396 61.3923 226.376 61.4163C226.328 61.4723 226.276 61.5323 226.224 61.5883C225.94 61.8963 225.896 62.4203 226.224 62.7203C226.532 63.0043 227.052 63.0483 227.356 62.7203C228.288 61.7083 228.832 60.4283 228.936 59.0563C228.96 58.6403 228.54 58.2403 228.128 58.2563Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.024 48.2079C211.776 47.8239 211.328 47.7199 210.928 47.9199C210.164 48.3039 209.4 48.6879 208.636 49.0759C208.26 49.2639 208.124 49.8239 208.348 50.1719C208.596 50.5559 209.044 50.6599 209.444 50.4599C210.208 50.0759 210.972 49.6919 211.736 49.3079C212.112 49.1159 212.248 48.5559 212.024 48.2079Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.268 44.5516C232.452 44.5076 231.636 44.4676 230.816 44.4236C230.396 44.4036 229.996 44.8076 230.016 45.2236C230.036 45.6756 230.368 46.0036 230.816 46.0236C231.632 46.0676 232.448 46.1076 233.268 46.1516C233.688 46.1716 234.088 45.7676 234.068 45.3516C234.048 44.8996 233.716 44.5756 233.268 44.5516Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.08 38.1756C225.952 37.9956 221.612 42.0996 221.42 47.3396C221.404 47.8596 221.428 48.3716 221.488 48.8756C221.48 48.8796 221.476 48.8796 221.472 48.8796C221.136 48.9316 220.8 48.9836 220.464 49.0356C220.256 47.0036 219.42 45.1036 218.032 43.5796C216.336 41.7156 214.036 40.6396 211.544 40.5476C209.052 40.4596 206.68 41.3596 204.852 43.0956C203.032 44.8276 201.98 47.1756 201.884 49.7116C201.792 52.2476 202.668 54.6676 204.36 56.5316C206.052 58.3956 208.356 59.4676 210.848 59.5596C210.96 59.5636 211.076 59.5676 211.192 59.5676C213.552 59.5676 215.796 58.6676 217.54 57.0156C219.3 55.3396 220.344 53.0836 220.492 50.6396C220.932 50.5716 221.372 50.5036 221.816 50.4356C222.932 54.2156 226.308 57.0356 230.388 57.1876C230.5 57.1916 230.616 57.1916 230.732 57.1916C233.096 57.1916 235.336 56.2956 237.08 54.6396C238.9 52.9116 239.952 50.5596 240.048 48.0236C240.236 42.7836 236.22 38.3636 231.08 38.1756ZM216.704 56.1436C215.112 57.6556 213.056 58.4396 210.884 58.3596C208.72 58.2796 206.716 57.3476 205.24 55.7236C203.76 54.0956 202.996 51.9756 203.076 49.7556C203.156 47.5356 204.08 45.4796 205.672 43.9636C207.188 42.5236 209.14 41.7436 211.196 41.7436C211.292 41.7436 211.392 41.7436 211.492 41.7476C213.656 41.8276 215.66 42.7676 217.136 44.3876C218.616 46.0116 219.38 48.1316 219.3 50.3516C219.224 52.5796 218.296 54.6356 216.704 56.1436ZM236.248 53.7716C234.66 55.2796 232.592 56.0636 230.428 55.9876C225.956 55.8236 222.452 51.9636 222.62 47.3836C222.784 42.9036 226.4 39.3716 230.744 39.3716C230.84 39.3716 230.94 39.3716 231.036 39.3756C235.508 39.5396 239.012 43.3996 238.84 47.9796C238.764 50.2036 237.836 52.2596 236.248 53.7716Z",
    fill: "#FFB533"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.96 30.6358C250.824 33.4718 249.268 36.1118 247.352 38.4838C247.256 40.0518 247.16 41.6158 247.064 43.1878C247.044 43.5478 246.504 43.7718 246.32 43.3878C244.756 40.1518 242.084 37.6358 238.94 35.9478C232.232 32.3438 224.316 32.9638 217.196 34.8758C210.212 36.7558 202.564 39.7358 198.904 46.4398C198.884 46.4758 198.856 46.4998 198.832 46.5238C198.752 46.7918 198.42 46.9758 198.184 46.7118L193.96 41.9078C192.816 40.6038 191.568 39.3478 190.552 37.9398C189.708 36.7718 189.144 35.2278 189.712 33.8118C190.212 32.5478 191.532 31.9358 192.832 31.9598C193.8 31.9798 194.68 32.3318 195.504 32.7998C194.448 30.8598 193.772 28.5918 195.336 26.7198C196.168 25.7238 197.508 25.3998 198.732 25.7998C199.548 26.0638 200.264 26.5478 200.908 27.1238C200.32 24.9678 200.192 22.5198 202.296 21.1958C203.776 20.2718 205.496 20.5438 206.66 21.5438C206.62 21.0238 206.644 20.4998 206.76 19.9878C207 18.9398 207.664 17.9358 208.672 17.5118C209.796 17.0358 211.068 17.4118 211.996 18.1318C212.612 18.6118 213.072 19.2398 213.464 19.9118C213.532 19.0358 213.696 18.1678 214.108 17.3878C214.628 16.4038 215.572 15.5718 216.704 15.4438C217.908 15.3038 219.02 15.9838 219.732 16.9078C220.188 17.4958 220.472 18.1758 220.672 18.8838C220.852 18.2118 221.104 17.5678 221.504 16.9918C222.148 16.0678 223.204 15.3318 224.364 15.3118C225.512 15.2958 226.48 16.0318 227.032 16.9998C227.284 17.4398 227.44 17.9118 227.54 18.4038C228.496 16.9038 230.364 15.9518 232.128 16.5238C233.692 17.0318 234.736 18.5318 234.916 20.1118C235.216 19.6998 235.556 19.3198 235.972 19.0078C236.86 18.3278 238.064 17.9678 239.144 18.3918C240.688 18.9878 241.204 20.3918 241.3 21.8838C241.516 21.6518 241.76 21.4438 242.036 21.2758C243.112 20.6158 244.536 20.6478 245.624 21.2718C247.436 22.3158 247.624 24.3598 247.372 26.2798C247.988 25.5358 248.74 24.9278 249.74 24.7518C251.036 24.5278 252.324 25.1438 252.688 26.4598C253.08 27.8558 252.468 29.3598 251.96 30.6358Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.136 182.408L107.236 200H156.376L144.384 171.008L108.136 182.408Z",
    fill: "#FF7550"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.904 133.916C121.8 142.376 116.092 149.748 109.104 155.376C101.476 161.516 91.972 166.08 82.004 165.916C73.092 165.772 64.252 161.656 59.764 153.708C57.612 149.892 56.592 145.4 57.244 141.036C57.948 136.312 60.308 132.088 61.824 127.612C64.628 119.324 64.652 110.396 67.388 102.092C68.7 98.1198 70.688 94.3798 73.616 91.3558C76.456 88.4158 80.04 86.2198 83.884 84.8598C87.764 83.4798 91.92 82.9038 96.032 83.1878C100.2 83.4838 104.252 84.7358 107.948 86.6638C115.408 90.5638 121.3 97.2238 124.76 104.848C124.828 105.004 124.8 105.148 124.724 105.256C124.828 105.508 124.936 105.752 125.032 106.004C128.448 114.904 128.168 125.008 124.904 133.916Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.2559 86.1397C75.5919 87.5397 71.2839 91.8837 68.4279 96.7997C65.1399 102.46 63.7519 108.928 61.8999 115.14C60.9479 118.328 59.7959 121.42 58.4279 124.452C57.1159 127.364 55.7199 130.256 54.7519 133.308C53.7959 136.336 53.3479 139.472 53.6479 142.644C53.9519 145.828 54.9639 148.964 56.5959 151.716C59.5319 156.672 64.4999 160.32 70.0919 161.692C70.7799 161.86 71.4719 161.996 72.1719 162.096C72.6919 162.172 72.7559 161.36 72.2399 161.284C66.7199 160.468 61.6039 157.392 58.3239 152.872C54.5919 147.732 53.5039 141.084 55.1119 134.976C55.8959 131.996 57.1679 129.176 58.4399 126.384C59.7399 123.532 60.9879 120.676 61.9599 117.688C63.9439 111.596 65.1559 105.2 67.9599 99.4037C70.3639 94.4357 74.1279 89.6917 79.3759 87.5877C80.0359 87.3237 80.7159 87.1077 81.4079 86.9357C81.9119 86.8157 81.7679 86.0117 81.2559 86.1397Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.964 74.3C85.036 76.94 82.808 80.304 81.532 84.036C81.36 84.532 82.128 84.808 82.3 84.312C83.532 80.712 85.672 77.468 88.5 74.92C88.884 74.568 88.356 73.948 87.964 74.3Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.7961 77.7285C89.4601 79.2845 86.4081 81.4085 83.7921 84.0005C83.4201 84.3685 83.9521 84.9844 84.3241 84.6164C86.8921 82.0684 89.8721 79.9884 93.1521 78.4604C93.6281 78.2404 93.2721 77.5045 92.7961 77.7285Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.392 177.78C148.408 180.172 146.7 182 144.54 183.38C142.144 184.912 139.432 186.036 136.76 186.984C131.34 188.9 125.404 190.06 119.636 189.816C117.076 189.708 114.46 189.188 112.264 187.808C110.304 186.584 108.696 184.68 108.136 182.412C107.972 181.744 108.06 180.832 107.58 180.3C107.196 179.884 106.56 179.744 106.048 179.552C104.944 179.136 103.948 178.504 103.08 177.704C101.132 175.896 100.36 173.488 100.116 170.9C99.648 165.984 99.312 161.048 98.952 156.124C98.784 155.46 98.644 154.792 98.516 154.124C97.676 149.58 97.884 144.488 100.764 140.66C101.464 139.736 102.252 138.932 103.112 138.224C104.108 136.976 105.372 135.94 106.752 135.112C109.148 133.676 114.036 130.156 116.808 129.756C121.832 129.036 125.752 132.34 129.62 135.344C133.776 138.568 136.148 143.928 139.356 148.08C142.712 152.424 145.608 157.172 147.852 162.188C150.024 167.028 151.5 172.648 149.392 177.78Z",
    fill: "#60BFB2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.284 143.796C105.416 143.528 104.596 143.94 104.244 144.76C103.964 145.412 103.684 146.064 103.404 146.72C103.076 147.488 103.58 148.516 104.368 148.76C105.236 149.028 106.056 148.616 106.408 147.796C106.688 147.144 106.968 146.492 107.248 145.836C107.58 145.068 107.072 144.04 106.284 143.796Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.508 144.236L116.232 142.928C115.648 142.332 114.632 142.152 113.98 142.768C113.384 143.332 113.196 144.38 113.82 145.02L115.096 146.328C115.68 146.924 116.696 147.104 117.348 146.488C117.944 145.92 118.132 144.872 117.508 144.236Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.976 153.412C113.584 152.856 113.192 152.3 112.8 151.744C112.32 151.06 111.132 151.032 110.548 151.584C109.868 152.228 109.872 153.104 110.388 153.836C110.78 154.392 111.172 154.948 111.564 155.504C112.044 156.188 113.232 156.216 113.816 155.664C114.496 155.016 114.492 154.144 113.976 153.412Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.056 161.464C105.84 160.932 105.62 160.4 105.404 159.868C105.088 159.096 103.992 158.744 103.272 159.136C102.472 159.572 102.2 160.44 102.54 161.268C102.756 161.8 102.972 162.332 103.192 162.864C103.508 163.636 104.604 163.988 105.324 163.596C106.124 163.164 106.392 162.296 106.056 161.464Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.096 173.632C108.844 172.992 108.588 172.348 108.336 171.708C108.028 170.932 106.92 170.584 106.204 170.976C105.396 171.416 105.14 172.276 105.472 173.108L106.232 175.032C106.54 175.808 107.648 176.156 108.364 175.764C109.172 175.324 109.428 174.464 109.096 173.632Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.128 167.5L116.66 165.16C116.22 164.456 115.34 163.984 114.528 164.428C113.836 164.808 113.32 165.804 113.796 166.564C114.284 167.344 114.772 168.124 115.26 168.904C115.7 169.608 116.58 170.08 117.392 169.636C118.088 169.256 118.604 168.26 118.128 167.5Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.712 157.236C125.308 156.492 124.372 156.092 123.58 156.504C122.796 156.912 122.016 157.316 121.232 157.724C120.492 158.108 120.08 159.088 120.5 159.856C120.904 160.6 121.84 161 122.632 160.588C123.416 160.18 124.196 159.776 124.98 159.368C125.716 158.988 126.128 158.008 125.712 157.236Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.324 145.848L124.708 145.656C123.876 145.596 123.02 146.248 122.984 147.112C122.952 147.968 123.552 148.768 124.44 148.836L127.056 149.028C127.888 149.088 128.744 148.44 128.78 147.572C128.812 146.712 128.212 145.912 127.324 145.848Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.58 134.564C125.588 134.472 124.592 134.38 123.6 134.284C122.744 134.204 121.948 134.888 121.876 135.74C121.804 136.608 122.472 137.384 123.332 137.464C124.324 137.556 125.32 137.648 126.312 137.744C127.168 137.824 127.964 137.14 128.036 136.288C128.108 135.416 127.44 134.644 126.58 134.564Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.956 150.36C135.776 149.544 134.952 148.884 134.096 149.088C133.276 149.28 132.632 150.076 132.824 150.948L133.296 153.096C133.476 153.912 134.3 154.572 135.156 154.368C135.976 154.176 136.62 153.38 136.428 152.508L135.956 150.36Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.776 160.308C133.536 159.48 132.82 158.864 131.916 159.036C131.132 159.184 130.4 160.068 130.644 160.896C130.904 161.792 131.168 162.688 131.428 163.584C131.668 164.412 132.384 165.028 133.288 164.856C134.072 164.708 134.804 163.824 134.56 162.996C134.3 162.1 134.036 161.204 133.776 160.308Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.548 171.184C128.108 170.556 127.668 169.924 127.224 169.296C126.744 168.612 125.556 168.588 124.972 169.136C124.292 169.78 124.3 170.652 124.812 171.388C125.252 172.02 125.692 172.648 126.136 173.28C126.616 173.964 127.804 173.988 128.388 173.44C129.068 172.792 129.06 171.92 128.548 171.184Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.492 181.608C117.988 181.072 117.488 180.536 116.984 180.004C116.412 179.396 115.376 179.236 114.732 179.844C114.124 180.42 113.96 181.444 114.572 182.096C115.076 182.632 115.576 183.164 116.08 183.7C116.652 184.308 117.688 184.468 118.332 183.86C118.94 183.284 119.104 182.26 118.492 181.608Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.08 181.656C126.352 181.592 125.624 181.528 124.896 181.464C124.064 181.392 123.208 182.064 123.172 182.92C123.14 183.788 123.74 184.564 124.628 184.644C125.356 184.708 126.084 184.772 126.812 184.836C127.644 184.908 128.5 184.236 128.536 183.38C128.568 182.512 127.968 181.736 127.08 181.656Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.876 176.512C136.264 175.864 135.324 175.792 134.624 176.352C133.924 176.912 133.228 177.468 132.528 178.028C131.876 178.548 131.792 179.672 132.368 180.28C132.98 180.928 133.92 181 134.62 180.44C135.32 179.88 136.016 179.324 136.716 178.764C137.368 178.244 137.452 177.124 136.876 176.512Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.16 170.004L139.144 169.008C138.796 168.836 138.236 168.916 137.908 169.076C137.564 169.244 137.224 169.6 137.108 169.972C136.828 170.876 137.272 171.616 138.072 172.012C138.744 172.344 139.416 172.676 140.088 173.008C140.436 173.18 140.996 173.1 141.324 172.94C141.668 172.772 142.012 172.416 142.124 172.044C142.404 171.136 141.96 170.4 141.16 170.004Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.604 163.392C145.524 163.364 145.448 163.328 145.372 163.296C145.22 163.2 145.072 163.112 144.932 163C144.896 162.972 144.796 162.864 144.82 162.892C144.8 162.872 144.788 162.852 144.78 162.844C144.728 162.788 144.68 162.732 144.632 162.672C144.58 162.612 144.368 162.292 144.596 162.648C144.36 162.284 144.124 161.996 143.7 161.848C143.328 161.716 142.816 161.724 142.464 161.916C141.776 162.288 141.248 163.3 141.732 164.048C142.424 165.124 143.324 165.936 144.532 166.392C145.312 166.688 146.32 166.24 146.572 165.428C146.828 164.592 146.436 163.708 145.604 163.392Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.152 172.98C146.316 172.72 145.428 173.112 145.112 173.944C144.788 174.808 144.46 175.668 144.136 176.532C143.84 177.312 144.288 178.32 145.1 178.572C145.936 178.832 146.824 178.44 147.14 177.608C147.464 176.744 147.792 175.884 148.116 175.02C148.412 174.24 147.964 173.232 147.152 172.98Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.432 173.592L116.108 174.028C115.288 174.184 114.636 175.048 114.836 175.888C115.032 176.732 115.82 177.328 116.696 177.16L119.02 176.724C119.84 176.568 120.492 175.7 120.292 174.864C120.096 174.024 119.312 173.428 118.432 173.592Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.116 135.46L104.912 138.444C104.912 138.444 113.04 140.54 114.696 132.596L112.568 130.796L104.116 135.46Z",
    fill: "#FF8B6C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.54 116.544C124.46 116.844 124.372 117.152 124.272 117.456C122.068 124.276 115.312 129.752 106.736 134.172C94.0681 140.704 81.8241 142.672 74.3641 132.348C70.4801 134.224 65.5881 133.128 62.6801 129.48C59.3201 125.268 59.8761 119.244 63.9121 116.016C65.3721 114.852 67.0921 114.208 68.8441 114.072C68.7441 103.26 73.4201 92.4039 82.7241 87.6079C91.9881 82.8279 103.508 85.2759 112.244 91.5839C112.244 91.5839 121.072 97.8639 124.08 106.712C124.06 106.724 124.04 106.732 124.02 106.744C125.22 110.284 125.32 113.54 124.54 116.544Z",
    fill: "#FCB190"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.6 139.304C81.156 138.5 76.248 135.268 73.388 130.56C72.52 129.128 71.844 127.592 71.384 125.98C71.276 125.6 70.668 125.724 70.776 126.108C72.412 131.796 76.6 136.488 82.088 138.712C83.528 139.296 85.032 139.692 86.564 139.92C86.964 139.984 86.992 139.364 86.6 139.304Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.8121 123.256C65.8881 122.248 64.7081 121.056 63.2241 121.132C62.5241 121.168 61.8401 121.512 61.5321 122.164C61.2521 122.756 61.3041 123.468 61.7681 123.952C62.0441 124.24 62.5001 123.82 62.2241 123.532C61.8881 123.18 61.9121 122.632 62.1921 122.248C62.5081 121.816 63.1041 121.7 63.6041 121.764C64.7281 121.9 65.6281 122.892 66.3521 123.68C67.1801 124.58 67.8961 125.584 68.4201 126.688C68.8561 127.604 69.5281 129.096 68.9041 130.06C68.5561 130.6 67.9281 130.636 67.4081 130.332C66.8001 129.98 66.5001 129.276 66.2161 128.668C66.0481 128.308 65.4961 128.592 65.6641 128.952C66.1801 130.064 67.1801 131.616 68.6521 131.048C70.1361 130.472 69.7961 128.58 69.3881 127.42C68.8441 125.864 67.9201 124.464 66.8121 123.256Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.632 121.476C90.868 123.876 89.928 126.828 87.528 128.064C85.128 129.3 82.18 128.36 80.94 125.96C79.7 123.56 80.644 120.612 83.044 119.372C85.444 118.132 88.392 119.076 89.632 121.476Z",
    fill: "#FF8B6C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.648 105.48C121.884 107.88 120.944 110.832 118.544 112.068C116.144 113.304 113.196 112.364 111.956 109.964C110.716 107.564 111.66 104.612 114.06 103.376C116.46 102.136 119.408 103.08 120.648 105.48Z",
    fill: "#FF8B6C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.012 113.556C91.848 115.176 91.464 117.032 90.152 117.708C88.844 118.384 87.108 117.62 86.272 116C85.436 114.38 85.82 112.524 87.128 111.848C88.44 111.176 90.176 111.94 91.012 113.556Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.02 104.268C109.856 105.884 109.472 107.744 108.16 108.42C106.852 109.096 105.116 108.328 104.28 106.712C103.444 105.096 103.828 103.236 105.14 102.56C106.448 101.888 108.184 102.652 109.02 104.268Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.892 114.876C106.924 115.784 105.656 116.484 104.332 116.652C103.16 116.8 101.892 116.552 100.952 115.796C100.9 115.76 100.86 115.716 100.812 115.676C100.324 115.344 99.8799 114.932 99.5159 114.416C98.8799 113.516 98.3399 112.244 98.6479 111.132C98.9479 110.048 100.108 109.52 101.16 109.568C102.54 109.64 103.64 110.548 104.912 110.948C106.076 111.316 107.564 110.8 108.48 111.832C109.348 112.808 108.7 114.124 107.892 114.876Z",
    fill: "#F27A51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.268 125.284C101.66 126.856 99.3079 127.4 97.1879 126.64C95.3839 125.992 92.9919 123.86 93.9119 121.724C94.3119 120.792 95.2639 120.152 96.2559 120.044C97.2159 119.936 98.1519 120.292 98.9239 120.848C99.2999 120.34 99.7559 119.896 100.32 119.588C101.256 119.076 102.476 118.984 103.424 119.516C105.676 120.784 104.764 123.824 103.268 125.284Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.244 91.5878C112.244 91.5878 100.4 88.2518 96.184 89.3718C96.184 89.3718 93.588 114.708 68.844 114.076C68.844 114.076 63.316 92.9478 83.084 85.9838C102.852 79.0158 112.244 91.5878 112.244 91.5878Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.464 83.72C92.12 84.108 82.176 88.596 75.184 96.256C75.068 96.38 74.964 96.512 74.852 96.64C75.196 95.82 75.528 94.992 75.828 94.152C76.7 91.704 77.64 88.992 76.748 86.412C75.972 84.172 73.292 82.416 71.004 83.736C68.876 84.964 68.364 88.016 68.128 90.24C67.844 92.928 68.184 95.648 69.068 98.196C69.304 98.876 69.672 99.58 69.932 100.3C65.504 100.812 61.352 103.572 59.192 107.472C58.604 108.528 58.024 109.732 58.052 110.968C58.08 112.196 58.756 113.32 59.984 113.668C62.236 114.304 64.632 112.628 66.172 111.156C67.968 109.44 69.304 107.312 70.588 105.204C70.816 104.828 71.044 104.44 71.24 104.044C71.412 104.004 71.576 103.896 71.696 103.692C76.568 95.432 84.54 89.232 93.8 86.676C96.58 85.908 99.452 85.448 102.332 85.34C102.772 85.324 103.172 85.072 103.212 84.596C103.24 84.204 102.908 83.704 102.464 83.72ZM69.84 89.672C70.096 87.924 70.784 84.26 73.344 85.032C74.62 85.416 75.268 86.652 75.444 87.896C75.652 89.356 75.208 90.836 74.764 92.212C73.908 94.88 72.812 97.472 71.5 99.944C71.216 99.112 70.816 98.308 70.532 97.48C69.676 94.988 69.456 92.276 69.84 89.672ZM68.684 105.2C67.416 107.236 66.052 109.288 64.132 110.772C63.3 111.416 62.292 112.048 61.224 112.164C60.176 112.276 59.576 111.672 59.7 110.62C59.844 109.392 60.6 108.172 61.304 107.184C62.028 106.168 62.9 105.272 63.88 104.508C65.716 103.076 67.912 102.184 70.212 101.916C70.208 101.956 70.216 101.996 70.212 102.04C70.092 103.188 69.28 104.24 68.684 105.2Z",
    fill: "#FFB533"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.2599 107.976C87.1599 107.796 87.0039 107.632 86.8039 107.568C86.6079 107.508 86.3519 107.488 86.1719 107.604C85.4359 108.084 84.6999 108.564 83.9639 109.048C83.7799 109.168 83.6319 109.288 83.5559 109.504C83.4879 109.696 83.4919 109.956 83.5919 110.136C83.6919 110.316 83.8479 110.484 84.0479 110.544C84.2439 110.604 84.4999 110.624 84.6799 110.508C85.4159 110.028 86.1519 109.548 86.8879 109.068C87.0759 108.948 87.2199 108.828 87.2959 108.612C87.3639 108.42 87.3599 108.16 87.2599 107.976Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.304 98.2845C104.136 98.1805 103.892 98.0925 103.692 98.1565C102.988 98.3885 102.284 98.6205 101.576 98.8525C101.36 98.9245 101.188 98.9965 101.056 99.1925C100.944 99.3565 100.88 99.6045 100.928 99.8005C100.976 100.004 101.084 100.208 101.268 100.324C101.436 100.428 101.68 100.516 101.876 100.452C102.58 100.22 103.284 99.9885 103.992 99.7565C104.208 99.6845 104.38 99.6125 104.512 99.4165C104.624 99.2525 104.688 99.0045 104.64 98.8085C104.596 98.6045 104.488 98.4005 104.304 98.2845Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.748 78.8925V195.236L127.6 193.82L111.388 76.2205C148.304 68.3805 196.748 78.8925 196.748 78.8925Z",
    fill: "#FF7550"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.108 76.2239L265.896 193.824L196.748 195.24V78.8919C196.748 78.8919 245.192 68.3799 282.108 76.2239Z",
    fill: "#FF7550"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.844 170.164C123.72 162.244 122.6 154.328 121.476 146.408C120.844 141.948 120.212 137.488 119.58 133.028C119.508 132.532 118.752 132.744 118.824 133.236L125.56 180.748C126.192 185.208 126.824 189.668 127.456 194.128C127.528 194.624 128.284 194.412 128.212 193.92L124.844 170.164Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.052 132.172L270.656 156.288L267.26 180.404L265.348 193.964C265.28 194.456 266.032 194.672 266.104 194.172C267.236 186.132 268.368 178.092 269.5 170.056L272.896 145.94L274.808 132.38C274.88 131.888 274.124 131.672 274.052 132.172Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.708 193.628L211.904 194.688C194.392 194.652 176.864 194.152 159.352 194.116C149.472 194.096 139.608 193.356 129.732 193.336C129.228 193.336 129.232 194.12 129.736 194.12L182.54 195.412C200.052 195.452 217.564 195.488 235.076 195.528C244.956 195.548 254.832 194.396 264.712 194.416C265.216 194.412 265.212 193.628 264.708 193.628Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.588 75.6796C192.588 75.6796 161.496 56.4636 116.996 65.7796L131.188 190.88L194.58 192.292L192.588 75.6796Z",
    fill: "#FFEED4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.748 78.0996V192.948C158.064 180.856 129.328 190.112 129.328 190.112L117 71.7836C159.048 52.8276 196.748 78.0996 196.748 78.0996Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.904 75.6796C200.904 75.6796 231.996 56.4636 276.496 65.7796L262.304 190.88L198.912 192.292L200.904 75.6796Z",
    fill: "#FFEED4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.496 71.7836L264.168 190.112C264.168 190.112 235.432 180.852 196.748 192.948V78.0996C196.748 78.0996 234.444 52.8276 276.496 71.7836Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.248 171.592V192.84C196.248 193.344 197.032 193.344 197.032 192.84V171.592C197.032 171.084 196.248 171.084 196.248 171.592Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.248 78.3077V89.3157C196.248 89.8197 197.032 89.8197 197.032 89.3157V78.3077C197.032 77.8037 196.248 77.8037 196.248 78.3077Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.616 180.876C139.96 178.164 135.94 174.424 132.912 169.968C132.628 169.552 131.952 169.944 132.236 170.364C135.344 174.932 139.448 178.772 144.224 181.556C144.66 181.808 145.052 181.132 144.616 180.876Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.928 183.368L132.648 180.74C132.164 180.588 131.96 181.344 132.44 181.496C135.2 182.372 137.96 183.248 140.72 184.124C141.204 184.276 141.408 183.52 140.928 183.368Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.224 190.772C233.4 191.236 220.576 191.7 207.756 192.164C204.112 192.296 200.464 192.428 196.82 192.56C196.724 192.564 196.652 192.6 196.592 192.648C184.068 191.616 171.508 191.032 158.944 190.908C155.368 190.872 151.792 190.876 148.216 190.916C147.712 190.92 147.712 191.704 148.216 191.7C160.828 191.564 173.444 191.884 186.032 192.668C189.6 192.888 193.168 193.148 196.732 193.444C196.86 193.456 196.956 193.408 197.02 193.336C209.776 192.876 222.532 192.416 235.288 191.952C238.932 191.82 242.58 191.688 246.224 191.556C246.728 191.54 246.732 190.756 246.224 190.772Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.064 73.8516C214.92 74.9996 213.8 75.6036 212.72 75.5116C212.22 75.4676 211.772 75.2876 211.376 75.0236C211.46 75.3276 211.516 75.6316 211.524 75.9516C211.544 76.8316 211.2 77.7596 210.456 78.2676C209.604 78.8516 208.456 78.6796 207.628 78.1436C207.36 77.9716 207.132 77.7636 206.924 77.5396C207.008 78.0916 207.048 78.6476 207.04 79.2076C207.028 80.0956 206.736 81.1436 205.736 81.3476C204.64 81.5716 203.676 80.5396 203.048 79.7876C202.824 79.5196 202.62 79.2396 202.428 78.9476C202.432 79.1596 202.436 79.3716 202.428 79.5836C202.404 80.2196 202.344 81.0356 201.74 81.4076C200.6 82.1036 199.488 80.6036 198.9 79.5796C197.692 77.9196 197.188 75.7756 197.596 73.7156C198.104 71.1396 199.956 68.8996 202.348 67.8436C204.86 66.7316 207.764 66.8356 210.228 68.0196C211.424 68.5956 212.508 69.4236 213.404 70.4036C214.22 71.3036 215.228 72.5436 215.064 73.8516Z",
    fill: "#F78B66"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.04 71.0843C259.276 71.9523 258.012 71.8243 257.168 71.1403C256.776 70.8243 256.508 70.4243 256.328 69.9843C256.228 70.2803 256.104 70.5643 255.928 70.8363C255.452 71.5723 254.644 72.1483 253.74 72.1523C252.708 72.1563 251.856 71.3683 251.472 70.4603C251.348 70.1683 251.272 69.8643 251.228 69.5643C250.984 70.0683 250.708 70.5523 250.388 71.0083C249.88 71.7363 249.048 72.4403 248.104 72.0443C247.072 71.6123 246.852 70.2163 246.756 69.2443C246.72 68.8963 246.712 68.5483 246.716 68.2003C246.6 68.3763 246.484 68.5563 246.36 68.7243C245.984 69.2363 245.476 69.8763 244.768 69.8483C243.432 69.7843 243.36 67.9203 243.444 66.7403C243.38 64.6883 244.164 62.6323 245.66 61.1563C247.528 59.3123 250.32 58.4963 252.888 58.9683C255.592 59.4603 257.936 61.1763 259.308 63.5403C259.972 64.6883 260.408 65.9843 260.596 67.2963C260.776 68.5043 260.912 70.0963 260.04 71.0843Z",
    fill: "#F78B66"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.724 78.9962L200.556 74.4682C200.464 74.2762 200.192 74.2282 200.02 74.3282C199.824 74.4442 199.788 74.6722 199.88 74.8642L202.048 79.3922C202.14 79.5842 202.412 79.6322 202.584 79.5322C202.78 79.4202 202.816 79.1882 202.724 78.9962Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.008 76.6364C206.34 75.3284 205.672 74.0164 205.004 72.7084C204.776 72.2564 204.096 72.6564 204.328 73.1044C204.996 74.4164 205.664 75.7244 206.332 77.0364C206.56 77.4844 207.236 77.0884 207.008 76.6364Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.664 74.6038C210.824 73.3518 209.984 72.1038 209.144 70.8518C209.028 70.6758 208.8 70.5998 208.608 70.7118C208.432 70.8158 208.348 71.0718 208.468 71.2478C209.308 72.4998 210.148 73.7478 210.988 74.9998C211.108 75.1758 211.332 75.2518 211.524 75.1398C211.696 75.0398 211.78 74.7798 211.664 74.6038Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.524 63.7643C247.2 65.1083 246.872 66.4523 246.548 67.7963C246.428 68.2883 247.184 68.4963 247.304 68.0043C247.628 66.6603 247.956 65.3163 248.28 63.9723C248.4 63.4843 247.644 63.2723 247.524 63.7643Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.336 64.5321L251.144 69.0961C251.016 69.5841 251.772 69.7921 251.9 69.3041L253.096 64.7401C253.22 64.2521 252.464 64.0441 252.336 64.5321Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.996 65.1241L255.828 69.5361C255.808 70.0401 256.592 70.0401 256.612 69.5361L256.78 65.1241C256.8 64.6201 256.016 64.6201 255.996 65.1241Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.916 69.444C211.192 67.664 208.796 66.592 206.316 66.54C203.836 66.488 201.4 67.476 199.604 69.18C199.236 69.528 199.792 70.08 200.16 69.736C201.808 68.172 204.04 67.28 206.316 67.324C208.596 67.368 210.784 68.368 212.364 70C212.712 70.36 213.268 69.808 212.916 69.444Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.416 58.8356C247.528 59.4036 244.952 61.2116 243.416 63.7196C243.152 64.1516 243.828 64.5436 244.092 64.1156C245.528 61.7716 247.928 60.1196 250.624 59.5916C251.12 59.4956 250.908 58.7396 250.416 58.8356Z",
    fill: "#332623"
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M177.77 131.773C176.853 131.773 176.025 131.617 175.285 131.306C174.552 130.989 173.945 130.54 173.466 129.959C172.993 129.372 172.685 128.676 172.543 127.872L174.478 127.581C174.673 128.356 175.081 128.961 175.702 129.395C176.323 129.824 177.048 130.038 177.876 130.038C178.391 130.038 178.864 129.959 179.296 129.8C179.728 129.636 180.074 129.404 180.335 129.104C180.601 128.799 180.734 128.435 180.734 128.012C180.734 127.784 180.693 127.581 180.61 127.405C180.533 127.229 180.423 127.076 180.281 126.947C180.145 126.812 179.977 126.697 179.776 126.604C179.58 126.504 179.364 126.419 179.128 126.348L175.853 125.388C175.534 125.294 175.208 125.174 174.877 125.027C174.546 124.875 174.241 124.678 173.963 124.437C173.691 124.191 173.469 123.888 173.297 123.53C173.126 123.166 173.04 122.726 173.04 122.209C173.04 121.428 173.241 120.768 173.643 120.228C174.052 119.682 174.602 119.271 175.294 118.995C175.986 118.713 176.761 118.572 177.619 118.572C178.483 118.584 179.255 118.737 179.935 119.03C180.622 119.324 181.189 119.746 181.639 120.298C182.095 120.844 182.408 121.508 182.58 122.288L180.592 122.623C180.503 122.148 180.314 121.74 180.024 121.399C179.734 121.053 179.379 120.788 178.959 120.606C178.539 120.419 178.083 120.322 177.592 120.316C177.119 120.304 176.684 120.375 176.288 120.527C175.897 120.68 175.584 120.894 175.347 121.17C175.117 121.446 175.001 121.763 175.001 122.121C175.001 122.473 175.105 122.758 175.312 122.975C175.519 123.193 175.773 123.366 176.075 123.495C176.383 123.618 176.687 123.721 176.989 123.803L179.35 124.464C179.645 124.546 179.98 124.657 180.352 124.798C180.731 124.933 181.095 125.124 181.444 125.371C181.799 125.617 182.092 125.946 182.322 126.357C182.553 126.762 182.669 127.273 182.669 127.889C182.669 128.529 182.538 129.093 182.278 129.58C182.018 130.061 181.66 130.466 181.204 130.795C180.755 131.118 180.234 131.362 179.642 131.526C179.051 131.691 178.427 131.773 177.77 131.773Z",
    fill: "#2F4F4F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M187.621 131.773C186.911 131.773 186.317 131.644 185.838 131.385C185.358 131.121 184.995 130.775 184.746 130.346C184.504 129.912 184.382 129.436 184.382 128.92C184.382 128.438 184.468 128.015 184.64 127.651C184.811 127.287 185.066 126.979 185.403 126.727C185.74 126.468 186.154 126.26 186.645 126.102C187.071 125.978 187.553 125.87 188.092 125.776C188.63 125.682 189.195 125.594 189.787 125.512C190.384 125.429 190.976 125.347 191.562 125.265L190.887 125.635C190.899 124.889 190.739 124.337 190.408 123.979C190.082 123.615 189.52 123.433 188.722 123.433C188.219 123.433 187.757 123.551 187.337 123.786C186.917 124.014 186.624 124.396 186.459 124.93L184.728 124.402C184.965 123.586 185.415 122.937 186.077 122.456C186.746 121.974 187.633 121.734 188.74 121.734C189.597 121.734 190.343 121.88 190.976 122.174C191.615 122.462 192.082 122.92 192.378 123.548C192.532 123.859 192.626 124.188 192.662 124.534C192.697 124.88 192.715 125.253 192.715 125.652V131.509H191.073V129.333L191.393 129.615C190.997 130.343 190.491 130.886 189.875 131.244C189.266 131.597 188.515 131.773 187.621 131.773ZM187.95 130.267C188.476 130.267 188.929 130.176 189.307 129.994C189.686 129.806 189.991 129.568 190.222 129.281C190.452 128.993 190.603 128.694 190.674 128.382C190.775 128.101 190.831 127.784 190.843 127.431C190.86 127.079 190.869 126.797 190.869 126.586L191.473 126.806C190.887 126.894 190.355 126.973 189.875 127.044C189.396 127.114 188.961 127.185 188.571 127.255C188.186 127.32 187.843 127.399 187.541 127.493C187.287 127.581 187.059 127.687 186.858 127.81C186.663 127.933 186.506 128.083 186.388 128.259C186.275 128.435 186.219 128.649 186.219 128.902C186.219 129.148 186.281 129.377 186.406 129.589C186.53 129.794 186.719 129.959 186.974 130.082C187.228 130.205 187.553 130.267 187.95 130.267Z",
    fill: "#2F4F4F"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M202.101 131.509V126.832C202.101 126.463 202.069 126.084 202.004 125.696C201.944 125.303 201.826 124.939 201.649 124.604C201.477 124.27 201.232 124 200.912 123.794C200.599 123.589 200.187 123.486 199.679 123.486C199.347 123.486 199.034 123.542 198.738 123.653C198.442 123.759 198.182 123.932 197.957 124.173C197.738 124.414 197.564 124.731 197.433 125.124C197.309 125.517 197.247 125.996 197.247 126.559L196.093 126.128C196.093 125.265 196.256 124.505 196.581 123.847C196.907 123.184 197.374 122.667 197.984 122.297C198.593 121.927 199.33 121.742 200.193 121.742C200.856 121.742 201.412 121.848 201.862 122.06C202.311 122.271 202.675 122.55 202.953 122.896C203.237 123.237 203.453 123.609 203.601 124.014C203.749 124.42 203.85 124.816 203.903 125.203C203.956 125.591 203.983 125.931 203.983 126.225V131.509H202.101ZM195.366 131.509V121.998H197.025V124.745H197.247V131.509H195.366Z",
    fill: "#2F4F4F"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M210.335 131.773C209.441 131.773 208.669 131.553 208.019 131.112C207.374 130.672 206.874 130.073 206.519 129.316C206.17 128.553 205.995 127.695 205.995 126.744C205.995 125.787 206.173 124.933 206.528 124.182C206.883 123.424 207.386 122.829 208.036 122.394C208.693 121.954 209.471 121.734 210.37 121.734C211.275 121.734 212.036 121.954 212.651 122.394C213.272 122.829 213.74 123.424 214.053 124.182C214.373 124.939 214.532 125.793 214.532 126.744C214.532 127.695 214.373 128.55 214.053 129.307C213.734 130.064 213.263 130.666 212.642 131.112C212.021 131.553 211.252 131.773 210.335 131.773ZM210.592 130.108C211.202 130.108 211.698 129.965 212.083 129.677C212.468 129.389 212.749 128.993 212.926 128.488C213.104 127.983 213.192 127.402 213.192 126.744C213.192 126.087 213.101 125.506 212.917 125.001C212.74 124.496 212.462 124.103 212.083 123.821C211.71 123.539 211.234 123.398 210.654 123.398C210.039 123.398 209.533 123.548 209.137 123.847C208.74 124.147 208.445 124.549 208.249 125.054C208.06 125.559 207.965 126.122 207.965 126.744C207.965 127.373 208.06 127.942 208.249 128.453C208.445 128.958 208.734 129.36 209.119 129.659C209.51 129.959 210.001 130.108 210.592 130.108ZM213.192 131.509V124.666H212.979V118.828H214.843V131.509H213.192Z",
    fill: "#2F4F4F"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M222.18 131.773C221.263 131.773 220.494 131.553 219.873 131.112C219.252 130.666 218.781 130.064 218.462 129.307C218.142 128.55 217.983 127.695 217.983 126.744C217.983 125.793 218.139 124.939 218.453 124.182C218.772 123.424 219.24 122.829 219.855 122.394C220.476 121.954 221.24 121.734 222.145 121.734C223.044 121.734 223.819 121.954 224.47 122.394C225.126 122.829 225.632 123.424 225.987 124.182C226.342 124.933 226.52 125.787 226.52 126.744C226.52 127.695 226.342 128.553 225.987 129.316C225.638 130.073 225.138 130.672 224.487 131.112C223.843 131.553 223.074 131.773 222.18 131.773ZM217.672 131.509V118.828H219.536V124.666H219.323V131.509H217.672ZM221.923 130.108C222.514 130.108 223.003 129.959 223.387 129.659C223.778 129.36 224.067 128.958 224.257 128.453C224.452 127.942 224.55 127.373 224.55 126.744C224.55 126.122 224.452 125.559 224.257 125.054C224.067 124.549 223.775 124.147 223.378 123.847C222.982 123.548 222.476 123.398 221.861 123.398C221.281 123.398 220.802 123.539 220.423 123.821C220.05 124.103 219.772 124.496 219.589 125.001C219.411 125.506 219.323 126.087 219.323 126.744C219.323 127.402 219.411 127.983 219.589 128.488C219.766 128.993 220.047 129.389 220.432 129.677C220.816 129.965 221.313 130.108 221.923 130.108Z",
    fill: "#2F4F4F"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M232.996 131.773C232.038 131.773 231.206 131.558 230.502 131.13C229.798 130.701 229.254 130.111 228.87 129.36C228.491 128.603 228.302 127.731 228.302 126.744C228.302 125.752 228.497 124.88 228.887 124.129C229.278 123.372 229.825 122.785 230.529 122.368C231.233 121.945 232.055 121.734 232.996 121.734C233.955 121.734 234.786 121.948 235.49 122.377C236.194 122.805 236.738 123.395 237.123 124.147C237.507 124.898 237.7 125.764 237.7 126.744C237.7 127.737 237.504 128.611 237.114 129.369C236.729 130.12 236.185 130.71 235.481 131.139C234.777 131.561 233.949 131.773 232.996 131.773ZM232.996 130.038C233.913 130.038 234.596 129.733 235.046 129.122C235.502 128.506 235.729 127.713 235.729 126.744C235.729 125.752 235.499 124.96 235.037 124.367C234.582 123.768 233.901 123.469 232.996 123.469C232.375 123.469 231.863 123.609 231.461 123.891C231.059 124.167 230.76 124.552 230.565 125.045C230.369 125.532 230.272 126.099 230.272 126.744C230.272 127.742 230.502 128.541 230.964 129.14C231.425 129.739 232.103 130.038 232.996 130.038Z",
    fill: "#2F4F4F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M238.68 131.509L242.265 126.7L238.76 121.998H240.96L243.348 125.265L245.708 121.998H247.909L244.404 126.7L247.998 131.509H245.788L243.348 128.136L240.889 131.509H238.68Z",
    fill: "#2F4F4F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 112,
    width: 31.0696,
    height: 26.4009,
    fill: "url(#pattern0_1136_2092)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.768 136.728C136.46 136.816 136.16 136.896 135.852 136.976C136.104 136.988 136.352 137.012 136.604 137.04C137.108 137.1 137.616 137.192 138.108 137.312C138.536 137.42 138.992 137.528 139.388 137.744C140.156 138.164 140.34 139.16 139.556 139.676C139.16 139.936 138.644 139.972 138.184 140.032C137.712 140.092 137.24 140.144 136.772 140.184C137.6 140.444 138.484 140.784 139.176 141.296C139.836 141.784 140.236 142.76 139.544 143.412C138.86 144.048 137.708 143.892 136.856 143.832C136.092 143.776 135.332 143.664 134.58 143.496C133.92 144.632 133.028 145.704 131.968 146.488C131.336 145.748 130.588 145.108 129.74 144.608C127.96 143.552 125.772 143.292 123.796 143.824C123.7 143.02 123.8 142.184 124.016 141.412C124.396 140.04 125.1 138.736 125.856 137.54C126.572 136.412 127.404 135.348 128.324 134.376C129.256 133.392 130.296 132.496 131.404 131.708C131.956 131.32 132.528 130.956 133.116 130.624C133.696 130.296 134.308 129.928 134.948 129.732C135.472 129.572 136.132 129.64 136.436 130.156C136.772 130.732 136.472 131.376 136.056 131.812C135.488 132.4 134.832 132.924 134.224 133.468C133.908 133.752 133.588 134.04 133.272 134.324C134.028 134.064 134.804 133.872 135.6 133.768C136.732 133.624 137.872 133.648 138.996 133.828C139.472 133.904 139.996 134.02 140.252 134.468C140.472 134.856 140.368 135.292 140.024 135.564C139.628 135.876 139.044 136.004 138.572 136.164C137.98 136.364 137.376 136.556 136.768 136.728Z",
    fill: "#FCB190"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.328 166.552C125.652 169.06 123.648 171.44 120.472 171.844C117.336 172.248 114.092 171.012 111.264 169.788C105.572 167.324 100.448 163.092 98.3361 157.096C98.2601 156.88 98.1921 156.656 98.1241 156.432C98.0281 156.232 97.9321 156.028 97.8481 155.824C96.6121 152.868 96.7881 149.496 97.6841 146.472C98.4481 143.892 99.7361 141 102.156 139.568C103.296 138.896 104.636 138.684 105.928 138.98C107.316 139.3 108.52 140.148 109.572 141.068C110.832 142.168 111.944 143.428 113.1 144.632C114.236 145.816 115.368 147 116.504 148.188C116.66 147.812 116.844 147.456 117.076 147.12C118.52 145.024 121.184 143.832 123.708 144.12C126.432 144.432 128.796 146.196 130.204 148.504C133.768 154.36 130.756 161.44 127.328 166.552Z",
    fill: "#60BFB2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.236 148.432C132.772 149.316 131.912 150.212 131.068 150.84C130.216 151.476 129.164 151.792 128.064 151.496C126.856 151.168 125.852 150.34 124.912 149.64C123.468 148.564 122.076 147.216 121.624 145.604C121.364 145.584 121.4 144.364 121.536 144.004C121.54 143.988 121.54 143.972 121.552 143.96C121.84 143.184 122.248 142.44 122.968 141.896C123.996 141.12 125.304 141.036 126.54 141.464C127.788 141.896 128.892 142.656 129.94 143.376C130.956 144.072 132.052 144.812 132.84 145.716C133.556 146.536 133.736 147.488 133.236 148.432Z",
    fill: "#60BFB2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.02 143.8C120.24 144.064 117.696 145.672 116.292 148.072C115.172 146.02 113.456 144.328 111.376 143.244C110.912 143.004 110.5 143.704 110.964 143.948C113.156 145.092 114.892 146.912 115.936 149.152C116.06 149.42 116.516 149.416 116.64 149.152C117.812 146.656 120.264 144.872 123.024 144.612C123.536 144.568 123.54 143.752 123.02 143.8Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.328 151.156C114.808 152.744 114.288 154.332 113.764 155.916C113.6 156.416 114.388 156.628 114.548 156.132C115.068 154.544 115.588 152.96 116.108 151.372C116.276 150.872 115.488 150.66 115.328 151.156Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.532 151.32C117.288 151.32 117.152 151.508 117.124 151.728L116.608 155.728C116.58 155.948 116.816 156.136 117.016 156.136C117.26 156.136 117.396 155.948 117.424 155.728L117.94 151.728C117.968 151.508 117.732 151.32 117.532 151.32Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.788 150.252C131.676 149.74 130.892 149.956 131.004 150.468C132.368 156.816 130.2 163.768 125.452 168.2C124.116 169.448 122.576 170.512 120.82 171.076C119.068 171.64 117.204 171.732 115.384 171.508C112.044 171.1 108.844 169.644 106.16 167.648C103.232 165.472 100.884 162.552 99.3839 159.232C99.1679 158.756 98.4679 159.168 98.6799 159.644C101.492 165.86 107.38 170.832 114.14 172.132C116.024 172.492 117.972 172.556 119.86 172.172C121.732 171.788 123.424 170.912 124.92 169.732C127.616 167.608 129.644 164.7 130.876 161.508C132.248 157.94 132.592 153.996 131.788 150.252Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.272 142.04C126.08 141.94 125.824 141.988 125.716 142.188C125.388 142.792 125.056 143.392 124.728 143.996C124.624 144.184 124.676 144.448 124.872 144.552C125.064 144.652 125.32 144.604 125.428 144.408C125.756 143.804 126.088 143.204 126.416 142.6C126.524 142.412 126.472 142.148 126.272 142.04Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.388 142.872C128.208 142.768 127.928 142.82 127.832 143.02C127.296 144.1 126.764 145.176 126.232 146.256C126.136 146.452 126.18 146.696 126.376 146.812C126.556 146.916 126.836 146.864 126.932 146.664C127.468 145.584 128 144.508 128.536 143.428C128.632 143.232 128.588 142.988 128.388 142.872Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.396 144.064C130.204 143.964 129.948 144.012 129.84 144.212C129.588 144.664 129.336 145.116 129.084 145.572C128.98 145.76 129.032 146.024 129.232 146.128C129.424 146.228 129.68 146.18 129.788 145.98C130.04 145.528 130.292 145.076 130.544 144.624C130.648 144.436 130.596 144.168 130.396 144.064Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.868 145.704C131.68 145.604 131.416 145.648 131.312 145.848L129.952 148.412C129.852 148.6 129.9 148.864 130.1 148.968C130.288 149.068 130.552 149.024 130.656 148.824L132.016 146.26C132.116 146.072 132.068 145.812 131.868 145.704Z",
    fill: "#332623"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.1 159.66C107.06 158.092 104.62 158.084 104.656 159.66C104.676 160.54 104.7 161.42 104.72 162.3C104.76 163.868 107.2 163.876 107.164 162.3C107.144 161.42 107.12 160.54 107.1 159.66Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.86 151.68C102.34 151.096 101.816 150.512 101.296 149.928C100.868 149.448 99.996 149.46 99.568 149.928C99.1 150.44 99.112 151.144 99.568 151.656C100.088 152.24 100.612 152.824 101.132 153.408C101.56 153.888 102.432 153.876 102.86 153.408C103.328 152.896 103.316 152.188 102.86 151.68Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.268 143.008C106.828 142.568 105.972 142.504 105.54 143.008C105.308 143.28 105.044 143.516 104.848 143.64C104.5 143.86 104.404 143.9 103.988 144.008C103.352 144.176 102.96 144.88 103.136 145.512C103.312 146.156 104 146.536 104.64 146.364C105.652 146.096 106.588 145.532 107.268 144.732C107.696 144.236 107.76 143.5 107.268 143.008Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.848 150.028C110.416 149.476 109.984 148.928 109.552 148.376C109.156 147.872 108.236 147.932 107.824 148.376C107.332 148.912 107.4 149.564 107.824 150.104L109.12 151.756C109.516 152.26 110.436 152.204 110.848 151.756C111.34 151.22 111.272 150.568 110.848 150.028Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.364 155.336C103.848 154.86 103.156 154.888 102.636 155.336L100.852 156.876C100.368 157.296 100.392 158.18 100.852 158.604C101.368 159.08 102.06 159.052 102.58 158.604C103.176 158.092 103.772 157.576 104.364 157.064C104.852 156.644 104.828 155.76 104.364 155.336Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.78 159.42C111.432 158.728 111.084 158.032 110.736 157.34C110.44 156.748 109.608 156.584 109.064 156.9C108.464 157.252 108.328 157.98 108.624 158.572C108.972 159.268 109.32 159.96 109.668 160.656C109.964 161.248 110.796 161.412 111.34 161.096C111.944 160.74 112.076 160.012 111.78 159.42Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.668 158.952C117.964 158.848 117.26 158.744 116.556 158.64C115.904 158.544 115.244 158.8 115.052 159.492C114.892 160.068 115.248 160.9 115.904 160.996C116.608 161.1 117.312 161.204 118.016 161.308C118.668 161.404 119.328 161.144 119.52 160.456C119.68 159.88 119.324 159.048 118.668 158.952Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.516 165.252L114.264 163.164C113.924 162.6 113.168 162.392 112.592 162.728C112.024 163.06 111.812 163.832 112.152 164.4L113.404 166.488C113.744 167.052 114.5 167.26 115.076 166.928C115.644 166.592 115.86 165.82 115.516 165.252Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.548 167.764L110.144 165.256C109.376 163.884 107.264 165.116 108.036 166.488C108.504 167.324 108.972 168.16 109.44 168.996C110.208 170.368 112.316 169.14 111.548 167.764Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.448 166.8C120.128 166.252 119.332 166 118.776 166.36L116.812 167.64C116.26 168 116.028 168.724 116.372 169.312C116.692 169.86 117.488 170.112 118.044 169.752L120.008 168.472C120.56 168.112 120.792 167.392 120.448 166.8Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.508 163.524C124.052 162.98 123.592 162.432 123.136 161.888C122.724 161.396 121.828 161.432 121.408 161.888C120.928 162.412 120.968 163.092 121.408 163.616C121.864 164.16 122.324 164.708 122.78 165.252C123.192 165.744 124.088 165.708 124.508 165.252C124.988 164.728 124.948 164.048 124.508 163.524Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.116 156.232C127.8 155.692 126.992 155.42 126.444 155.792L124.336 157.236C123.792 157.608 123.548 158.308 123.896 158.908C124.212 159.448 125.02 159.72 125.568 159.348C126.272 158.868 126.972 158.388 127.672 157.904C128.22 157.528 128.464 156.828 128.116 156.232Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.58 155.644C122.436 154.864 122.296 154.08 122.152 153.3C122.036 152.652 121.244 152.284 120.648 152.448C119.964 152.636 119.676 153.3 119.796 153.952C119.936 154.732 120.08 155.516 120.224 156.296C120.34 156.944 121.132 157.312 121.728 157.148C122.408 156.96 122.696 156.296 122.58 155.644Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.916 148.404C123.16 148.084 122.4 147.764 121.644 147.444C121.036 147.188 120.336 147.264 119.972 147.884C119.672 148.396 119.8 149.296 120.412 149.556C121.168 149.876 121.928 150.196 122.684 150.516C123.292 150.772 123.992 150.7 124.356 150.08C124.652 149.564 124.528 148.66 123.916 148.404Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.132 149.608C127.584 149.32 126.756 149.432 126.46 150.048C126.152 150.684 125.848 151.324 125.54 151.964C125.264 152.54 125.364 153.308 125.98 153.636C126.524 153.924 127.356 153.812 127.652 153.196C127.96 152.556 128.268 151.92 128.572 151.28C128.848 150.704 128.748 149.932 128.132 149.608Z",
    fill: "#49AD9C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_1136_2092",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 300,
    height: 200
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M344 0H44V200H344V0Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_1136_2092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.972 159.688C128.436 159.372 127.592 159.532 127.3 160.128C126.916 160.916 126.532 161.704 126.148 162.496C125.86 163.088 125.988 163.816 126.588 164.168C127.124 164.48 127.968 164.324 128.26 163.728C128.644 162.94 129.028 162.152 129.412 161.36C129.7 160.764 129.572 160.04 128.972 159.688Z",
    fill: "#49AD9C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1136_2092",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1136_2092",
    transform: "matrix(0.00536553 0 0 0.00625978 -0.142857 -0.166667)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1136_2092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 200,
    fill: "white",
    transform: "translate(44)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1136_2092",
    width: 213,
    height: 213,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANUAAADVCAYAAADAQLWDAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAB4iSURBVHgB7Z3dchtXcsf7ACBBSrIN1fpjd+1Iw9rsZm+SULnNhchL27Vr6QlMPoGsJ5D0BKKfQPQTSErKdm5Sgq5zIboqX3a5ikPKu44dO+JKFEWCwEy6zwwkkARm+pz5OgP2rwpFihqCAOb8T/fp06cbQBAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEwT0UCE4S3gUPmrCIjw7+08M79QY+Oi8vCGAr/s7H733ow4a6CjsgVI6IyhHCf4YlLSKAj/BBXztgDomqi4+HEEJXfQgbIJSOiKpCYiGRiFbATkRp+Pi4BwfwKVoxH4RSEFFVQPg5ikjBx/jtEpRHF63XZ2i91kEoFBFVicRiugG0RqoOH8V1S8RVHCKqEojdPBLTErhDF93CVXEL80dEVSAYwetAW4vpE3AVBTfV+3ALhNwQURVE+CW6eCE8gGpdPS4+Wq1lsVr50AAhd1BQH6OgHkE9BEV4aFEfaDdVyIyIKmdQUDdQUOtQTIi8SGiz+UH4hcOuak0Q9y9HYkHdhHzw8e5QGPwr6Ovvd/RXYhYFG+AjxAdtGCv4e/yesi4WIQ9knZUJEVUCLzbBGzTRJcLB28SBG6L1UeMtkN/28f924Qpko4uP+7i+WbdJOdLruABfbx57YCIsa0RUI2gRNeAKCuijAGBRMV24mR8BWj+CLTso2k+hB2t55u7FgZKb+O3HYMnhL2Gj/+axzyCEHaX06/SDELZwBG30BrBxfkGCHENOvaiebEJnrgXXcLAshRazexOH1+x3YEckpptFJsJmFdfBAkBwlnWpj48NnIzuHw6ge5pFdmpF9ewxLDVCPdCuKMugguoBtL/Fr4HZ74WzONtTCLvEhNfwc732uguGEclwJhIWvmZT7pHAzl04fZkbpy76h5bJe74Nd5q4h4RiWlEZonTtTXNB9X8BsP876Lz4W7i7u60TaUth9++gs/978Onvm6AO0RL/CWy4goPrzt42bJb5Pl3g1FiqoZuH64BPVA7hbpt11OGvIlEdwz8YwHJR7hJZ5FYIN0ZdW3rdM/m8dhN8nH9unQbLdSpERQMLLdMdyGkzlty+uW/414c4ZfcuJq9NcPF/c/6v8ou2kUWea8KdSevE1s8orO+BTdhEN/A3Vm7gcfxgAFfPLUzvWa+pF9XeYx2EWIMcmfs6cou49C4ADF5nXZqL1aL3HGJwIs0iN5+YuXY0KdD6KifWzlyA6zCFTK2oyN2bbcJtBfn686bRPgu3aSccwOrZBbgHhti8Z1NX0CAayKFQ17cqpjJQQa5PuxUFIiBnZn7gX3v4ttU6pKOacPfFY53dzka/5yY8Mn3P/bfZVlQzY78fNw79mp9vZt40d4qpE1U8uB6gy5dHyg4d6PsU1wCr+Lg0swm3uG4fhaJpwNpC7htXWPieF/V7tlwzHr4bvV4OjefRI0f0JLK3NT05h1Pl/r0UVJaARAgbuLi/3whgff6YWxJ+oZ97ifM0h+/B6uEbsKSUfUYDwQlgUNgaMgZhms9gZ3aLGRVtQXf3tzjBNGCxoeAyRIVqPMhI3sGaqpgaUdF6gly+DBaqOxjArdcWdP7dCeLMhE3goGBdvQ+r9C2lPgUN3A+LxOWBBWmDbRctFc72Dyy3CvT7PgcYjfsvvTm8xPidHTiAhdFMkGebuJne0OUCPsq0ZRHC9TMX8w0slc3UuH/tps4QtxGUj4NqGSNRy5MEpQkM3JP9VwIga3f2Ikbi8G8ElJZkQZorSOFpDG4sh8BPd8KBv46vaWH4vtUC/u6AbSXoRPPK6A/oOfB9rjTQTSZ3GcAy+KDg9ovvsln3qpkKS0UDLrQ4ckGD/NxFnljQ9eO5WCNWahxkuUJLFzUni9VFMa3OT4i4Gbi4XfUBLE/6zxELbRRwidlBYS7XdS+r9qKK11E8t+wVZJ1WEy3TCEauX+QW+WmX7W7BGq5HroEhtsLSVowRqo+L1DwADgdwPi0ZOMMkQuH2S+cX6ld1t/buX5s7AF7hkyvGFZQmYGevd7l1HshConU1XpRbuYIYfCG3jLP3pf6gPxfeQG6nfy5kEdHFXLBwfb1208rKVU6tRRUPLo/9Czi45nFwzZtuNipdRZbz/J+BAbTWitcfRmhhJaw7hsKi73EwfzYfwLLRe+a+j5B/VMZyEvmkjntYtRUVuX2G6yhfBXBV2bgTIVO4PQPrF4MCWLcSFob804RFARgczCvG7zlgZnPQMX4DaBKh6J7J76Are5siu1AjaiuqWTPXQLt88xbpMLp2H6/2g29b4qsoYRm5uKP0dYCAI0TjaCuFyw0tljfbqNfGcC1FRVbKJB1nkBDtSqXFHDgKvoIMkLBMZ3EiTVg26OBDyPq8OuHncBEM0W6vwRoLgzPX6mStaikqEytFs6L1jK2fgHkzg+zhX4tZXFOEsAwmifNgAa2xFLDvS6dO1qp2ojK0UnrjFbLQYgdCfMgBer1OCCtkvh+VIT0JPQjuhnWdrFXtRDVjUJyFTppCVviWyoeccERYPuuq0H6gk0uu+O+zNtaqdqJqNpmDBsPnrh/dTpp5nbFYBRPn+fmcaxUwtzYqpgU1QofRmZYqUHZ5dmO4x3KF+maWaphRj3tt65MyJEhYz7e062O0CRoLC+bfM9s3qwoKJDU5m/gYhaXE3Uxr5BKolagMXD8/LysVlxHLNQdt9IhKnCEBp1lYJJK9bT0peWnXNhp6DHTBYWrl/jWaPPOP4dr74CjjznylpR5lcQVpZocaEDKzOOrgAtZtTcXbMwrcXEslHaIsSljoVt2lJFtwnF7APEOFLqDrUcDauH/xB+kxLvXHHRnQmRGUuU0h8kaGMHAGDnfgRpj8t28ePgDV2puwPvt38PvvwEYwYySSTiuEB4N/hVuN/THh6wHsqD+aF5nJG8pGf7ENXc6auRldU/lrnkRtRNWizIYw/bowjDYt4zLHS3GbmSWAaoQ0CrPO3o2kAzmWjRBoQrk99nlbWsBODFB02x8qlS6qeF0losqKCrRIEqGCJDM/wcXwC3gCw/NEDCEKbhAE0G0ysmWUAxNkEvUR1YTTrGqAYkKnpvX0ZZUf59cPpwGc2NZwQrsMKnY5FVrEALbQ3dxA/80f15yhj1HWJuO5lWF2fNnUKaTujf6DxESli5s/mTcJEErhaHY/eQzkacQjDkXnA21VUKS2Fx3upHUVM7QugYo8wNnpjeH3VCWWilqalF4WnMPTDwVXoK1F1qXDkXto2VS6yy6iygPt/vWi2t85F3MU3ICCSkvz/40ByfPoCnaSmyGEf4aL6tfoTjpIbfapKOpFDdZEUDnThI5L+1jkfeh7vRmVmCY3v27UQlToGtzGD3pJ1k75g/tmnQZuSLu2QfxSXN9G7n6dcFpUtGEb16Gr1XHqGqKFRRkf4Bi6k+N3kdtPfcHqgLNrKl1rL9BliPOaQX2Iok1bOrwb5lNPrn8OvKBjXkoL3ZoN3AzOK5P+BP3XYTF4nVFX8FUMu9OOhOVkaxvqpdXYBei9F7XycXU9RTgpqrh45YNMp0ojuvi4Dwdwz7YoSxIjuXxmUKm0AJbVPxRbKHIXh51hwU5vKCz4T3AOslq01srSTaUMnHP/dI5eYN5FfQQqWnJLV0/9AAfuB7BWsKA8k997KagSKq9SHYggND76od9XcM68oMsxdgCKeY+01sKJ19lCmwocA9dQJKgrYAj11e2/qZusbZxZgEtQIHUQ1ChosdYbhi192K1LQ1hVHyafCsCJ0tOJzE3tyl+GnFrv4Oi9qd53r/WOU6LSs49FowHqBKgbl8Xrg4MBnC+qBjc1WJu1a1vTnR9YFvPMAVNh5Smqsb8WJTxTAIpE5oEtDgrLGfdPF8Y3FJTu+v5e1Kg6HEkaazfyb0tK2AqKXDBqWaMqLLZPlWotXMHCoNw/dM1X8LFAwgTbalQ4ZlxzBZ2wVC8DEwYzFrXTpKbO43bdqZ7c/IXJbV5Sn/uLCa+lhSF+FQmK/i6nUzsNZBrQ4Ahci1W0pToOnZc7uwNPWj9Zpp8pFOj7bkwarlgqo0YDSYLS/w+wlHEz0xv76EOHbrh+MPZMXBMU4ZrFGoK39Ao1Haf7atLY+yUhrOm1mwNULqrYSq2wr08R1Esa1Q5mFwU1xEVhqVYU+qf7Su78oXnYvAOzcDc+4V0p1VuqEO4YXO0fenAvVVCg92c+ripDwGVBDXFJWM8ew5I61lqW9qKOr5VToaMms9Vn31QqKh2cMKg4iwK82muxsxAoQ+A2lEwdBDXEFWG1wvGBBnIDtVdiJqwbOrJYIdVaKpN2OLihSxEj3fSZX/ftimWJLg8sqJOghlQtLFz7riQVewnneAGhI6jyJ9NRKhOVXksZFMdEQd0c/qPP76JOJbrumJS0emIZ4KijoIbQ6w7D8ptWk3veYEysJKzeu2DCUuwFVUKVlopvpQ6OhscNrZU319RZGqkM96HAkDoLakgvgGUbYfV+DTds165xSySPc21wXvfv4icgV9gvuDpRhcxUJAXr43L3TKwVuRdJhSoJKupvu7Fbd0ERlIFiJazmyyRcz+TX9h7DNZPGfUD3u6e9FZ/5G5VZq0pEFf6TFhRv8O6PF4+htdIVYCc1ZSZBUYlkU0FRxdhpENQQa2GBmbAo2kf7SsAE78u6brtDHR5N2rhWZK2qsVQzzHrYCu4nZpgbNA0ji3J24WQBxqGgwBDcAM7eUM5BhsLC91eIsMjFboQ8d5zQ93fEK1F/0BMpN7CyVMW+VTWiCplmOUwe7NymYZNcNFtBTTskrJkfrA5QJgrLJneS7u+Jfs3KYDJrl+9JlC6qeA/BY1y6oz5IL+1LTcOS3EARVPnMjfmZVTIyuqFxU7gjqPeNSlWX3iWkfEs1YC5oFTwELoPxWc4iqNLx1QCWj1sWy+x+XwVwdeL/DtiWtHQXsHxRNdmuXxeY0E0MBnB1dH0lgiqdPAUF4QCuzyfUyojXVj5waJcbBSxfVIp5TDs065ZH7XMGcWSoJEH5IAwZKyiK8lkJCtdR44JKJy9kNvcLp11UIc/9G1fAPo3X8UagsJbFQpUHimmsoOjzboaWguJGVQPmuqrkhgZVWCqPcZUPloxrsiyCKo6ZP5+Mztl+3kaCIvrsibfUBNsqQuqcmcuHnKCdexFUeZQmKERvBvM2qjtlBivq1vPXCJ2aZLBzL2SjTEG9REWdM1OZfdU1pmimVlQkqNCiMpNNs2qhIkHpJ2AW0wnA9ACJNVMpqiyCmsbUo6KpTFCEYi4VSmye7motdWv/VwRVLv234SMUFO/EwQi5fd5kqRQ4RRWWimOurUQlgiqfoF2hoBzFVVF5YIgIqh7k/nkr91qVViEq1t6CSfEOEVQ9KOTzDpmiCsrLgKkio2KLeSVLVCKoelDY563KC0BwcdZS4Su7nHaJjjqJoJyn4M+bl0vaL6+wTfmiajATZVNqWNBBuCAw39hNu8EkVBByI+3zpvuYsegpx6PZ0dkXJVG6qOIDZqwI4KTCHcP+UKbJmijU60k3WFKa8oUjKLqP8Wlh44BDvO7m/F5pVoqoavOXl7I/oXCHSWmrIQHA6rhTpEMkpSlfuIKCuPkDt4zcERT7bB4vlSknqqpR0WVeeeLUJlU0NSptBZGgzl2YbIFsgx3CeAwFFf0O3uu9bePKstyj8qfAUvX0ORiej9t+Za24FU1HEUHZEbxhdwbJRlAjfLK3xWswYFThuGd24DUrlYgqXjTyXED8oId9h+ZaOojgARdcQyUJihj02SH+ozTd23TMC5po+q+Zd8/IKKgIxa54y51cN4popJ5EdQm1A4OAQFvXQ/dMLArd4KQ11JBzC7AemBRojAnmYDGt6m0dKWrfz6D5eAfXV4ntleKeZkvAemEGBYRyojJRxYU7uszLl87+bFTjvGuyL2IrLBp80ySsIjfS47ZGHnCeD+/3pGrCMXyPpVd+8Knaox8G9dBbP4PHaQkKURESY4GcdmHZCqr1FNY4Exjek+tgcKJboQjHhdljK8V1TUt3/YhKRWVirfCmQHsz+ppICJ8mlbZK4rQKK0uwpvEXXrhaVxMewDK3TDfizTbGioc+Z956NrSqspuZ6g8pGlgramCdIiyfs45KgoQFFmhh1TAbo8zoJwkrjCwWC6Xg2qi1Cv8Frhn0h6aeZutQAZWLKrZW99jX708WFobPKz0KT9kYdRJWFdsJ8aTFvd+ddtwQXbt9gcFrrbAsghvH6Q+0y8XOzdLC+ha/Hl1j+Wnh8zKoi7Cq3J87MOjWgtbqo3gdRYEq7jZGZVaKcEJUet+qb7aWGbqCjefRv6u2UqO4LqyqN7ypqwh7vdPD0HkDHoHZ/mSlY8GZwi/qj+gSGC4sh8Ka+RH/8bT8nrVJuCosVzJIegGspVkr8kTo/uK6m7/RTp03P6zWY3GqmhJ+GBTt6YIhLRTV2W24G37uVldD14TlUkpWmrVSL+K18yGY4E/qvFkm7pUoO9DtU3wwx8NZ6k74BWy6JC5XhOVijmNvwnk43JO0EZR2+6rYlzqOY8WdIkYWph7YQ6Wr7sEh3Ef3oWtySA2FGaZdE5xF/RuUZ1QYxZp/j91WM1dsBEWuV+sx3GrtpQzSnv5sk69Jem3b8CCME2PJOs3+z6t1shEkqA/dmDScFBWhhUUL1EFuiatdiI4AbGFQxMd3rkUWh/SP/u0CRKX/VgXCio9TGCfHpmX358XuFnzSPITbM/8L0HwCtnTVB7AMjuBqMU19Qngfw+azNm7AeJZgeFTg1bv28WEojZiBFqVZm5jIFYSyhPV8Wyemrpj8DgUP8HG9DEHpk93/kbl9qB8vGZzBWVERwSx0Dv4aXyS6BC37WawQGvuwgS7VQ9xHMUpPKktYJChlIyjq77VQTCRVH+GZ1SHyy3ENkqxeCAlqucz6ExycFdULOuqBX8MmwOG7+HUmDp07BCWSPt/SG5RHhNV8ho+nCb9I4eQvi+vuF7bBC/5k/vzqAPzGC7iGry3HFxMdl4dIQJ34Z3k87wau5666EJg4jtOWapT+2+hxdSyjQgUyTli04E5ZH9DgWoGCoIyT5j7YsAglN0iz5B4KatU1CzWkVl0/wlmA/b9By/V2ZLlcgYQlLXhKgqJ8H2gL5aSgiFq20iGrRZG3/nlwBhFWsdAk2nvLnbB5Es6KKu1MFFktWmsd/BZ962hn3oeKEWEVQ/8XeJ8xYHX4jnvrp3E4bak4mcxBGzqU3oQuwQLuP1FolV+pqQBIWI2n1WzyThvDvcDDX0UBq7rgdKBCAWsviMoGdyiXTCflxmd19B5IA8O2Spfa4lYyzYXmC725LFhCYqJ1M3098vOBu+uoUVyP/tF+iZd2USsSTXf0Z8eP6us9kpbO0vBePqcq7CaVJuBpIWzoWoPQ75wU0xAFIqrMBCFsNRgzfrNxUlTHifczfCgDBxuROYrOz+y/BYu4blpMc/FEVHkQoKVi+NJ0OhS/rIHgMr7uz9vQgaWvqPQ3roV15sbzx/BIMTaEDx0IRnFw2vOntVK7CawEpYMBnNdndHKAk1ALCUmccf33I9Zq//e42TtrmNJELWD+D67OfZc8mBKfOwS/+QNcnfmxslk+sY2NwT3eOXMBHNpEmYzTlopEsretB5SXdm1cIMQJaxUPouMDaWxKUwqd8B24s/MmLJ9P3mKY9Ny6LNjsP7o7w7da6LozpjAFbp3sTsL5zV9cV7FqrscuoNNY7mN5cf8mz/C5taBsayCWRSPkHeAclNwOJwvOiyoMeOWs6KDbs83iklTzggY/ThSm+1imwqqFoAjF7NzBHQcu4LyoXluALrecVatZjyqx5y7CSpHCmh/ApToI6tljLSiPc21f3L+cYVZZImu1u+1W8ZdJFCkstVCP0DPX9UNr1j1fk/dE1GLf3yQKiOxgJHAhy03IGv0zYXcL1nEvzrQwjI/vMS14YQy+b2oRmnr0Q6eEZSRurbPJubaso/15UQtLRQIJ+bM6CfAOFE8uG7xFWixjXh0oTHtkZtbAVW8Oyu2EmJXaHP1oBEYp/1e4bS4n4DOuyS1rwhlh8TJBfMjI0224wj3qj9et12F9OEptREUfbGBSwVbBbet6eyHLdfQgRxwRlse4JtPahlx53BxlN8zuD+qX8V+rQ4qHaK1Cg5uKYdi13U2L4+GKNzOGn8NFsGBcMzOiSmHhe+F+TplE1Y7cPo9zLQUoKPoLNaNWotLHO8w2TzsNHHDGFitkN9c2DlRQYUscWI8miaAyYQ2Yv5thE3bvMVwDgxqE/UE9D3zW7jg9NXVTZvXWO7osmFmnQ+6eCNsKknWismFxpdhEEVQirBlmRoqyW9/oHr4hP42M1lJ1tFJELWtUgEF/oyE0mGlQMwcdT1TM1Cj8m4tknY4tzlOFpcybNdgLi9vtfWC+CUvvH0wjsjW1UkQtRaWDFgPzqqQ0qGnQpW0Qx0cSWMEKfcJ4AmSdhu4ejF9HJIpgH99jGBoPYmNhxespzvU748pkJ0GudzyhsKOllGpVt4jfKPW0VBClL+Hsyu4fO4KHb/rO3jZspoiLN5gbJ0U1FBPuxWwyGgNMFAGtIXsBLFsK6xE7u6Sh1zocjF6HbowQGG/a+pxu9y5TW1ERtL7KUL3oiLjGDGpWdjyav2vx+SmdyzYqJoPZuQhhdeL3d3tStPElXNePuc6j96G7eRh2GtHnxwbuNBqwRcEU8HwLB7DKnkxLaxgMEDwMGtBt/QT+3Pe8NJr+m9A9/GUu2Qb+mQvjU4BIGLMNeIDv03yLAJ+X2reOS/XRvbwUc71zAAtJZZbpNc614Bp+hp8oi83xEN3dswv1yUafxFSIishLWKOM9hROggo9Ul26LGW0ON02MgqLOCEuapIHvMlgYq5jVjHp14EeR93dviFTIyoib2E1fwaY/Z53LZXUosq5lujAC6fbRg7C0n8PH/faX+OkccjcNwph9XgvXXJ3myF8hJPBisqQtjVNgiKmSlQEHVRsRuFbDzKC/j20v4m+pkFW6uA3UeVcI3CtpAK4ahLtykNY1Clx7hvetfjedg5+B5eCJiyiALyGgst0zEblkP84bYIipk5UBLXhwXURWS273L8RqEk3t4WPaXdFymXE/SirxN/4OAxNHlfAgrmv+d1TMlrhiUyjoIipFNWQ3U1YaRjkmo3DxFoRGLQADFokg9ZpEMD1PDIGdrdgDS0HNySuoUmixZwo9HpxwcICpz4xXKfoLUwhtQ6pp4FrlHUK0YahfaYzuXVUIJ8LRg11d/Wxz0UbytFgupRXCo62dPic3AwTE0ER1FklZ0HR+vHStAqKmGpLNUoWl1Bbq2/Nms0dvheVMCZiMX16JoC1oo66686TuNcFCVa5hX955jtgQ1aK+oHlBbm7ZwO8BzU6Gm/DqRHVEBp8qJElU7eQQutt1q7VKwZv4QL/TVg9Q+HokgYSRUBpQ/p4EIGs5wwzkjmk9y6+h3zKV/qDAazWNUHWlFMnqlHorFWjAStoSS5zImk0KCe5dhNRODO/X25y6HGrbPO6yeWlFjZZKMNCu8ipFtUoIUbTdgEWVQOFhiFjmunDYzUZbNzA6Mmrafp8+G9okffgAWcDe5Ssm9mnVUxDRFSGhF+iyEKddW66R0MdLtbKslr4Om/g66RwvdHrpJY2WlCGwQmdtwcY1RzArdPi5k1CRGWBUb7cSXzdDPrDYkpuxa/NehuhdwHXUa+zL/cpXxKF9BC36O6dRqs0DhGVJTh4b0K2lCgfH5/CAQ7GjG6hzpKfw70qC8t05HnOwb19Tw+Kcc/h49bEXwIKiQfgv1Zi8KVuiKgykIOw4ifCNZdCl2kA96EPG0mtZ/Tl1BWyiYGVFlyG6Ej/EmQlrEfn9zogospIbsI6Ci30/THtUz2Ak72vMiOCyhURVQ7E6xiqZZfvYC8eneFR1PrutCKiyok4KpiY0eAYFDC5OmwRKuTHVOf+lQmGyn0MOlzCb63zDEsj1AGSSyKoYhBLVQBZw9oF4lN5N9OKSIIZIqqC0GHuWQxxKyca0ekMB+jh5vNVCYMXjYiqYOK11k38lsLfHpSLiKkCRFQlocUV6P2ka5CtvgSHLlCJtQNYFzGVj4iqAmLrRcfgqWz0EuRDF5/zIVql9bITd4WjiKgqRq+9WrrWOFkvchFpr8uDya6ir/tnNTByRx04qLY5IwtDEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBEARBON38P7nk+wogrACXAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPop1);
export default __webpack_public_path__ + "static/media/pop_1.5a2c8b9d4b36907baf63d3af80724ada.svg";
export { ForwardRef as ReactComponent };